<template>
  <div>
    <el-form
      class="c-form"
      :model="formData"
      ref="formData"
      :label-width="labelWidth"
      :label-position="labelPosition"
      :inline="inline"
      :disabled="disabled"
      :size="size"
      v-if="formShow"
    >
      <!-- type:
          item.type == 'date' || item.type == 'time' || item.type == 'datetime'
            ? 'date'
            : item.type == 'number'
            ? 'number'
            : item.multiple || item.type == 'area'
            ? 'array'
            : '', -->
      <template v-for="(item, i) in fields">
        <!-- pc表单展示的字段 -->
        <template
          v-if="
            item.showList &&
              item.showList.indexOf('2') != -1 &&
              (currentNode && currentNode.nodeDef
                ? currentNode.nodeDef.formFieldIdsHide
                  ? !currentNode.nodeDef.formFieldIdsHide.includes(item._id)
                  : true
                : true) &&
              !item.frontEndConfig.salesAttribute
          "
        >
          <!-- 字段查看权限 -->
          <template v-if="osg.showType(item, formData, currentRole && currentRole._id)">
            <template
              v-if="
                item.type == 'cascade' ||
                  item.type == 'file' ||
                  item.multiple ||
                  item.name == 'area' ||
                  item.type == 'inventoryItem'
              "
            >
              <el-form-item
                :class="
                  currentNode
                    ? currentNode.nodeDef.formFieldIdsReadOnly.indexOf(item._id) != -1 &&
                      (item.type == 'request'
                        ? item.frontEndConfig.componentType == 'table'
                          ? false
                          : true
                        : true)
                      ? 'c-no-pointer ' + item.class
                      : item.class || ''
                    : item.class || ''
                "
                :key="i"
                :label="item.nameDisp"
                :prop="item.preset ? item.name : 'exts.' + item.name"
                :rules="{
                  required:
                    item.required == '1'
                      ? currentNode &&
                        currentNode.nodeDef.formFieldIdsReadOnly.indexOf(item._id) != -1
                        ? false
                        : true
                      : false,
                  trigger: ['change', 'blur'],
                  message: '不能为空',
                  type: 'array'
                }"
              >
                <template v-if="attrsCustomizeList.includes(item.name)">
                  <template v-for="attr in attrsCustomizeList">
                    <slot :name="attr" v-if="attr == item.name"></slot>
                  </template>
                </template>
                <template v-else>
                  <!-- 展示计算后的值 -->
                  <template
                    v-if="item.type == 'compute' && osg.renderCompute(item.frontEndConfig.formula)"
                  >
                    <span>{{ osg.renderCompute(item.frontEndConfig.formula) }}</span>
                  </template>
                  <!-- 仅展示：不使用组件，防止F12修改表单值 -->
                  <template v-else-if="item.type == 'onlyShow'">
                    <span>
                      {{
                        item.preset
                          ? Array.isArray(formData[item.name])
                            ? formData[item.name].join('、')
                            : formData[item.name]
                          : Array.isArray(formData.exts[item.name])
                          ? formData.exts[item.name].join('、')
                          : formData.exts[item.name]
                      }}
                    </span>
                  </template>
                  <!-- 数组 -->
                  <template v-else-if="item.type == 'data'">
                    <template v-if="item.preset">
                      <template v-if="formData[item.name] && Array.isArray(formData[item.name])">
                        <template v-for="(item, i) in formData[item.name]">
                          <div :key="i">
                            {{ item }}
                          </div>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <template
                        v-if="formData.exts[item.name] && Array.isArray(formData.exts[item.name])"
                      >
                        <template v-for="(item, i) in formData.exts[item.name]">
                          <div :key="i">
                            {{ item }}
                          </div>
                        </template>
                      </template>
                    </template>
                  </template>
                  <!-- 单选 -->
                  <template v-else-if="item.type == 'radio'">
                    <template v-if="item.preset">
                      <el-radio-group v-model="formData[item.name]" class="c-flex">
                        <el-radio
                          v-for="opt in options[item.valueOption]"
                          :label="
                            item.frontEndConfig.fieldType == 'number' || item.frontEndConfig.number
                              ? Number(opt.value)
                              : opt.value
                          "
                          :key="opt._id || opt.value"
                        >
                          {{ opt.label }}
                        </el-radio>
                      </el-radio-group>
                    </template>
                    <template v-else>
                      <el-radio-group v-model="formData.exts[item.name]" class="c-flex">
                        <el-radio
                          v-for="opt in options[item.valueOption]"
                          :label="
                            item.frontEndConfig.fieldType == 'number' || item.frontEndConfig.number
                              ? Number(opt.value)
                              : opt.value
                          "
                          :key="opt._id || opt.value"
                        >
                          {{ opt.label }}
                        </el-radio>
                      </el-radio-group>
                    </template>
                  </template>
                  <!-- 多选 -->
                  <template v-else-if="item.type == 'checkbox'" @change="$forceUpdate()">
                    <template v-if="item.preset">
                      <el-checkbox-group v-model="formData[item.name]" @change="$forceUpdate()">
                        <el-checkbox
                          v-for="item in options[item.valueOption]"
                          :label="item.value"
                          :key="item._id || item.value"
                        >
                          {{ item.label }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </template>
                    <template v-else>
                      <el-checkbox-group
                        v-model="formData.exts[item.name]"
                        @change="$forceUpdate()"
                      >
                        <template
                          v-if="
                            item.frontEndConfig.optionField &&
                              item.frontEndConfig.optionField.indexOf('.') != -1
                          "
                        >
                          <el-checkbox
                            v-for="item in options[item.valueOption || item.name].filter(it => {
                              return (
                                (
                                  formData.exts[item.frontEndConfig.optionField.split('.')[1]] || []
                                ).indexOf(it._id) != -1
                              );
                            })"
                            :label="item.value"
                            :key="item._id || item.value"
                          >
                            {{ item.label || item.name }}
                          </el-checkbox>
                        </template>
                        <template v-else-if="item.frontEndConfig.optionField">
                          <el-checkbox
                            v-for="item in options[item.valueOption || item.name].filter(it => {
                              return (
                                (
                                  formData[item.frontEndConfig.optionField.split('.')[1]] || []
                                ).indexOf(it._id) != -1
                              );
                            })"
                            :label="item.value"
                            :key="item._id || item.value"
                          >
                            {{ item.label || item.name }}
                          </el-checkbox>
                        </template>
                        <template v-else>
                          <el-checkbox
                            v-for="item in options[item.valueOption]"
                            :label="item.value"
                            :key="item._id || item.value"
                          >
                            {{ item.label }}
                          </el-checkbox>
                        </template>
                      </el-checkbox-group>
                    </template>
                  </template>
                  <!-- 下拉 -->
                  <template v-else-if="item.type == 'select'">
                    <template v-if="item.preset">
                      <el-select
                        v-model="formData[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        :multiple="item.multiple"
                        filterable
                        :allow-create="item.frontEndConfig.allowCreate"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                      >
                        <el-option
                          v-for="opt in options[item.valueOption]"
                          :key="opt._id || opt.value"
                          :label="opt.label"
                          :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="formData.exts[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        :multiple="item.multiple"
                        filterable
                        :allow-create="item.frontEndConfig.allowCreate"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                      >
                        <el-option
                          v-for="opt in options[item.valueOption]"
                          :key="opt._id || opt.value"
                          :label="opt.label"
                          :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </template>
                  <!-- 业务对象版下拉 -->
                  <template v-else-if="item.type == 'bizSelect'">
                    <template v-if="item.preset">
                      <el-select
                        v-model="formData[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        filterable
                        :allow-create="item.frontEndConfig.allowCreate"
                        :remote="item.frontEndConfig.remote ? true : false"
                        :remote-method="
                          query => {
                            return bizSelectRemote(query, item);
                          }
                        "
                        :reserve-keyword="item.frontEndConfig.remote && item.multiple"
                        :multiple="item.multiple"
                        @change="
                          value => {
                            return bizSelectChange(item, value);
                          }
                        "
                        @focus="
                          value => {
                            return bizSelectFocus(item, value);
                          }
                        "
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        class="biz-select"
                      >
                        <i class="el-icon-search" slot="prefix" style="width: 25px"></i>
                        <el-option
                          v-for="item in options[item.valueOption]"
                          :key="item._id || item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="formData.exts[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        filterable
                        :allow-create="item.frontEndConfig.allowCreate"
                        :remote="item.frontEndConfig.remote ? true : false"
                        :remote-method="
                          query => {
                            return bizSelectRemote(query, item);
                          }
                        "
                        :reserve-keyword="item.frontEndConfig.remote && item.multiple"
                        :multiple="item.multiple"
                        @change="
                          value => {
                            return bizSelectChange(item, value);
                          }
                        "
                        @focus="
                          value => {
                            return bizSelectFocus(item, value);
                          }
                        "
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        class="biz-select"
                      >
                        <i class="el-icon-search" slot="prefix" style="width: 25px"></i>
                        <el-option
                          v-for="item in options[item.valueOption || item.name]"
                          :key="item._id || item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </template>
                  <!-- 参照 -->
                  <template v-else-if="item.type == 'request'">
                    <!-- 参照-单选 -->
                    <template v-if="item.frontEndConfig.componentType == 'radio'">
                      <template v-if="item.preset">
                        <el-radio-group v-model="formData[item.name]" class="c-flex">
                          <el-radio
                            v-for="opt in options[item.valueOption]"
                            :label="
                              item.frontEndConfig.fieldType == 'number' ||
                              item.frontEndConfig.number
                                ? Number(opt.value)
                                : opt.value
                            "
                            :key="opt._id || opt.value"
                          >
                            {{ opt.label }}
                          </el-radio>
                        </el-radio-group>
                      </template>
                      <template v-else>
                        <el-radio-group v-model="formData.exts[item.name]" class="c-flex">
                          <el-radio
                            v-for="opt in options[item.valueOption]"
                            :label="
                              item.frontEndConfig.fieldType == 'number' ||
                              item.frontEndConfig.number
                                ? Number(opt.value)
                                : opt.value
                            "
                            :key="opt._id || opt.value"
                          >
                            {{ opt.label }}
                          </el-radio>
                        </el-radio-group>
                      </template>
                    </template>
                    <!-- 参照-多选 -->
                    <template
                      v-else-if="item.frontEndConfig.componentType == 'checkbox'"
                      @change="$forceUpdate()"
                    >
                      <template v-if="item.preset">
                        <el-checkbox-group v-model="formData[item.name]" @change="$forceUpdate()">
                          <el-checkbox
                            v-for="item in options[item.valueOption]"
                            :label="item.value"
                            :key="item._id || item.value"
                          >
                            {{ item.label }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </template>
                      <template v-else>
                        <el-checkbox-group
                          v-model="formData.exts[item.name]"
                          @change="$forceUpdate()"
                        >
                          <el-checkbox
                            v-for="item in options[item.valueOption]"
                            :label="item.value"
                            :key="item._id || item.value"
                          >
                            {{ item.label }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </template>
                    </template>
                    <!-- 参照-下拉 -->
                    <template v-if="item.frontEndConfig.componentType == 'select'">
                      <template v-if="item.preset">
                        <el-select
                          v-model="formData[item.name]"
                          :placeholder="item.placeholder || '请选择'"
                          clearable
                          filterable
                          :allow-create="item.frontEndConfig.allowCreate"
                          :remote="item.frontEndConfig.remote ? true : false"
                          :remote-method="
                            query => {
                              return bizSelectRemote(query, item);
                            }
                          "
                          :reserve-keyword="item.frontEndConfig.remote && item.multiple"
                          :multiple="item.multiple"
                          @change="
                            value => {
                              return bizSelectChange(item, value);
                            }
                          "
                          @focus="
                            value => {
                              return bizSelectFocus(item, value);
                            }
                          "
                          :disabled="
                            item.operationType == '2'
                              ? true
                              : item.operationType == '3'
                              ? formData._id
                                ? true
                                : false
                              : false
                          "
                        >
                          <el-option
                            v-for="item in options[item.valueOption]"
                            :key="item._id || item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </template>
                      <template v-else>
                        <el-select
                          v-model="formData.exts[item.name]"
                          :placeholder="item.placeholder || '请选择'"
                          clearable
                          filterable
                          :allow-create="item.frontEndConfig.allowCreate"
                          :remote="item.frontEndConfig.remote ? true : false"
                          :remote-method="
                            query => {
                              return bizSelectRemote(query, item);
                            }
                          "
                          :reserve-keyword="item.frontEndConfig.remote && item.multiple"
                          :multiple="item.multiple"
                          @change="
                            value => {
                              return bizSelectChange(item, value);
                            }
                          "
                          @focus="
                            value => {
                              return bizSelectFocus(item, value);
                            }
                          "
                          :disabled="
                            item.operationType == '2'
                              ? true
                              : item.operationType == '3'
                              ? formData._id
                                ? true
                                : false
                              : false
                          "
                        >
                          <el-option
                            v-for="item in options[item.valueOption]"
                            :key="item._id || item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </template>
                    </template>
                    <!-- 参照-表格 -->
                    <template v-if="item.frontEndConfig.componentType == 'table'">
                      <!-- 参照-表格-预置 -->
                      <template v-if="item.preset">
                        <template
                          v-if="
                            options[(item.valueOption || item.name) + 'Actions'] &&
                              options[(item.valueOption || item.name) + 'Actions'].length > 0
                          "
                        >
                          <template
                            v-for="(action, index) of options[
                              (item.valueOption || item.name) + 'Actions'
                            ]"
                          >
                            <el-button
                              :key="index"
                              @click="actionClick(action, item)"
                              :type="action.buttonType || 'primary'"
                              size="small"
                            >
                              {{ action.name }}
                            </el-button>
                          </template>
                        </template>

                        <el-button
                          v-else-if="item.frontEndConfig.addable"
                          @click="requestClick(item)"
                          type="primary"
                          size="small"
                          :disabled="
                            currentNode &&
                            currentNode.nodeDef.formFieldIdsReadOnly.indexOf(item._id) != -1
                              ? true
                              : false
                          "
                        >
                          添加
                        </el-button>

                        <el-table
                          :data="formData[item.name]"
                          style="width: 100%;"
                          :max-height="item.frontEndConfig.height || '350px'"
                          ref="requestTable"
                          highlight-current-row
                          border
                          row-key="id"
                          @selection-change="requestTableSelect"
                          :cell-class-name="tableCellClassName"
                          @cell-click="
                            row => {
                              tableEditingChange(formData[item.name], row);
                            }
                          "
                        >
                          <!-- <el-table-column type="selection" width="55" fixed></el-table-column> -->
                          <c-table
                            @setoptions="setOptions"
                            :fields="options[(item.valueOption || item.name) + 'Fields']"
                            :options="requestOptions"
                            :listEditable="true"
                            :action="true"
                            :data="formData[item.name]"
                            :selection="true"
                          ></c-table>
                          <el-table-column
                            width="60px"
                            fixed="right"
                            v-if="item.frontEndConfig.editable"
                          >
                            <template slot-scope="scope">
                              <el-link
                                type="primary"
                                @click="requestEdit(item, scope.row)"
                                :disabled="
                                  currentNode &&
                                  currentNode.nodeDef.formFieldIdsReadOnly.indexOf(item._id) != -1
                                    ? true
                                    : false
                                "
                              >
                                编辑
                              </el-link>
                            </template>
                          </el-table-column>
                          <el-table-column
                            width="60px"
                            fixed="right"
                            v-if="item.frontEndConfig.deletable"
                          >
                            <template slot-scope="scope">
                              <el-link
                                type="danger"
                                @click="requestRemove(item, scope.row, scope.$index)"
                                :disabled="
                                  currentNode &&
                                  currentNode.nodeDef.formFieldIdsReadOnly.indexOf(item._id) != -1
                                    ? true
                                    : false
                                "
                              >
                                删除
                              </el-link>
                            </template>
                          </el-table-column>
                        </el-table>
                      </template>
                      <!-- 参照-表格-exts -->
                      <template v-else>
                        <template
                          v-if="
                            options[(item.valueOption || item.name) + 'Actions'] &&
                              options[(item.valueOption || item.name) + 'Actions'].length > 0
                          "
                        >
                          <template
                            v-for="(action, index) of options[
                              (item.valueOption || item.name) + 'Actions'
                            ]"
                          >
                            <el-button
                              :key="index"
                              @click="actionClick(action, item)"
                              :type="action.buttonType || 'primary'"
                              size="small"
                            >
                              {{ action.name }}
                            </el-button>
                          </template>
                        </template>

                        <el-button
                          v-else-if="item.frontEndConfig.addable"
                          @click="requestClick(item)"
                          type="primary"
                          size="small"
                        >
                          添加
                        </el-button>
                        <el-table
                          :data="formData.exts[item.name]"
                          style="width: 100%;"
                          :max-height="item.frontEndConfig.height || '350px'"
                          ref="requestTable"
                          highlight-current-row
                          border
                          row-key="id"
                          @selection-change="requestTableSelect"
                          @cell-click="
                            row => {
                              tableEditingChange(formData.exts[item.name], row);
                            }
                          "
                        >
                          <!-- <el-table-column type="selection" width="55" fixed></el-table-column> -->
                          <c-table
                            @setoptions="setOptions"
                            :fields="options[(item.valueOption || item.name) + 'Fields']"
                            :options="requestOptions"
                            :listEditable="true"
                            :action="true"
                            :selection="true"
                          ></c-table>
                          <el-table-column
                            fixed="right"
                            width="60px"
                            v-if="item.frontEndConfig.editable"
                          >
                            <template slot-scope="scope">
                              <el-link type="primary" @click="requestEdit(item, scope.row)">
                                编辑
                              </el-link>
                            </template>
                          </el-table-column>
                          <el-table-column
                            fixed="right"
                            width="60px"
                            v-if="item.frontEndConfig.deletable"
                          >
                            <template slot-scope="scope">
                              <el-link
                                type="danger"
                                @click="requestRemove(item, scope.row, scope.$index)"
                              >
                                删除
                              </el-link>
                            </template>
                          </el-table-column>
                        </el-table>
                      </template>
                    </template>
                  </template>
                  <!-- 级联 -->
                  <template v-else-if="item.type == 'cascade'">
                    <template v-if="item.preset">
                      <el-cascader
                        :placeholder="item.placeholder || '请选择'"
                        :popper-class="
                          item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                        "
                        :ref="item.valueOption + 'Cascade'"
                        v-model="formData[item.name]"
                        :options="options[item.valueOption]"
                        :props="{
                          emitPath: item.frontEndConfig.emitPath == false ? false : true,
                          multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                          label: item.frontEndConfig.label || 'name',
                          value: item.frontEndConfig.value || 'value',
                          children: item.frontEndConfig.children || 'children',
                          expandTrigger: item.frontEndConfig.propsExpandTrigger
                            ? item.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: item.frontEndConfig.propsCheckStrictly
                            ? item.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        filterable
                        @change="
                          if (item.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[item.valueOption + 'Cascade'] &&
                              $refs[item.valueOption + 'Cascade'][0]
                            ) {
                              $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          $forceUpdate();
                        "
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                      ></el-cascader>
                    </template>
                    <template v-else>
                      <el-cascader
                        :placeholder="item.placeholder || '请选择'"
                        :popper-class="
                          item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                        "
                        :ref="item.valueOption + 'Cascade'"
                        v-model="formData.exts[item.name]"
                        :options="options[item.valueOption]"
                        :props="{
                          emitPath: item.frontEndConfig.emitPath == false ? false : true,
                          multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                          label: 'name',
                          expandTrigger: item.frontEndConfig.propsExpandTrigger
                            ? item.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: item.frontEndConfig.propsCheckStrictly
                            ? item.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        filterable
                        @change="
                          if (item.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[item.valueOption + 'Cascade'] &&
                              $refs[item.valueOption + 'Cascade'][0]
                            ) {
                              $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          $forceUpdate();
                        "
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                      ></el-cascader>
                    </template>
                  </template>
                  <!-- 日期 日期时间 -->
                  <!-- <template v-else-if="item.type == 'date' || item.type == 'datetime'">
                  <template v-if="item.preset">
                    <el-date-picker
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? formData._id
                            ? true
                            : false
                          : false
                      "
                      v-model="formData[item.name]"
                      :value-format="item.type == 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'"
                      :type="item.type"
                      :placeholder="item.placeholder || '请选择日期'"
                    ></el-date-picker>
                  </template>
                  <template v-else>
                    <el-date-picker
                      v-model="formData.exts[item.name]"
                      :value-format="item.type == 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'"
                      :type="item.type"
                      :placeholder="item.placeholder || '请选择日期'"
                    ></el-date-picker>
                  </template>
                </template> -->
                  <!-- 时间 -->
                  <!-- <template v-else-if="item.type == 'time'">
                  <template v-if="item.preset">
                    <el-time-select
                      v-model="formData[item.name]"
                      value-format="HH:mm:ss"
                      :placeholder="item.placeholder || '请选择时间'"
                    ></el-time-select>
                  </template>
                  <template v-else>
                    <el-time-select
                      v-model="formData.exts[item.name]"
                      value-format="HH:mm:ss"
                      :placeholder="item.placeholder || '请选择时间'"
                    ></el-time-select>
                  </template>
                </template> -->
                  <!-- 上传文件 -->
                  <template v-else-if="item.type == 'file'">
                    <el-upload
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? formData._id
                            ? true
                            : false
                          : false
                      "
                      :class="{
                        'c-upload-maxLimit': item.preset
                          ? formData[item.name] &&
                            formData[item.name].length >= item.frontEndConfig.max
                          : formData.exts[item.name] &&
                            formData.exts[item.name].length >= item.frontEndConfig.max
                      }"
                      :action="upload.url"
                      :data="upload.data"
                      :file-list="item.preset ? formData[item.name] : formData.exts[item.name]"
                      :multiple="item.frontEndConfig.multiple || true"
                      :list-type="item.frontEndConfig.listType || 'picture-card'"
                      :limit="item.frontEndConfig.limit || 10"
                      :on-exceed="osg.uploadExceed"
                      :before-remove="beforeRemoveCon"
                      :before-upload="
                        file => {
                          return osg.beforeUpload(file, item.frontEndConfig.fileType);
                        }
                      "
                      :on-success="
                        (response, file, fileList) => {
                          return uploadSuccess(
                            response,
                            file,
                            fileList,
                            item.preset
                              ? formName + '.' + item.name
                              : formName + '.exts.' + item.name,
                            false
                          );
                        }
                      "
                      :on-error="osg.uploadError"
                      :on-remove="
                        (file, fileList) => {
                          return beforeRemove(
                            file,
                            fileList,
                            item.preset
                              ? formName + '.' + item.name
                              : formName + '.exts.' + item.name,
                            false
                          );
                        }
                      "
                      :on-preview="osg.uploadPreview"
                    >
                      <el-button
                        icon="el-icon-plus"
                        round
                        v-if="item.frontEndConfig.listType == 'text'"
                      >
                        点击上传
                      </el-button>
                      <i class="el-icon-plus" v-else></i>
                      <div
                        slot="file"
                        slot-scope="{ file, fileList }"
                        v-if="
                          osg.videoFormat.indexOf(
                            file.name &&
                              file.name.split('.')[file.name.split('.').length - 1].toLowerCase()
                          ) != -1
                        "
                        style="width: 100%; height: 100%"
                      >
                        <span class="el-upload-list__item-actions" style="z-index: 100">
                          <span
                            class="el-upload-list__item-preview"
                            @click="osg.uploadPreview(file)"
                          >
                            <i class="el-icon-video-play"></i>
                          </span>

                          <span
                            class="el-upload-list__item-delete"
                            @click="
                              beforeRemove(
                                file,
                                fileList,
                                item.preset
                                  ? formName + '.' + item.name
                                  : formName + '.exts.' + item.name,
                                false
                              )
                            "
                          >
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>

                        <video
                          style="width: 100%; height: 100%; object-fit: fill; border-radius: 0"
                          :src="file.url"
                          class="avatar"
                          controls="controls"
                        >
                          您的浏览器不支持视频播放
                        </video>
                      </div>
                    </el-upload>
                    <el-dialog
                      :modal="false"
                      custom-class="dialog-img"
                      :visible.sync="upload.dialogVisible"
                    >
                      <img width="100%" :src="upload.dialogImageUrl" />
                    </el-dialog>
                  </template>
                  <!-- 开关 -->
                  <!-- <template v-else-if="item.type == 'switch'">
                  <template v-if="item.preset">
                    <el-switch
                      v-model="formData[item.name]"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                    ></el-switch>
                  </template>
                  <template v-else>
                    <el-switch
                      v-model="formData.exts[item.name]"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                    ></el-switch>
                  </template>
                </template> -->
                  <!-- 评分 -->
                  <!-- <template v-else-if="item.type == 'rate'">
                  <template v-if="item.preset">
                    <el-rate v-model="formData[item.name]" @change="$forceUpdate()"></el-rate>
                  </template>
                  <template v-else>
                    <el-rate v-model="formData.exts[item.name]" @change="$forceUpdate()"></el-rate>
                  </template>
                </template> -->
                  <!-- 省市区 -->
                  <template v-else-if="item.type == 'area'">
                    <template v-if="item.preset">
                      <el-cascader
                        :placeholder="item.placeholder || '请选择'"
                        :popper-class="
                          item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                        "
                        ref="area"
                        v-model="formData[item.name]"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        :options="area.options"
                        :props="{
                          emitPath: item.frontEndConfig.emitPath == false ? false : true,
                          multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                          label: item.frontEndConfig.label ? item.frontEndConfig.label : 'label',
                          expandTrigger: item.frontEndConfig.propsExpandTrigger
                            ? item.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: item.frontEndConfig.propsCheckStrictly
                            ? item.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        filterable
                        @change="
                          if (item.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[item.valueOption + 'Cascade'] &&
                              $refs[item.valueOption + 'Cascade'][0]
                            ) {
                              $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          if (formData.subdistrict) {
                            formData.subdistrict = '';
                          }
                          osg.getSubdistricts(formData.area, result => {
                            options.subdistricts = result;
                            $forceUpdate();
                          });
                          scriptToCalculate(item, formData);
                        "
                        collapse-tags
                      ></el-cascader>
                    </template>
                    <template v-else>
                      <el-cascader
                        :placeholder="item.placeholder || '请选择'"
                        :popper-class="
                          item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                        "
                        ref="area"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        v-model="formData.exts[item.name]"
                        :options="area.options"
                        :props="{
                          emitPath: item.frontEndConfig.emitPath == false ? false : true,
                          multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                          label: item.frontEndConfig.label ? item.frontEndConfig.label : 'label',
                          expandTrigger: item.frontEndConfig.propsExpandTrigger
                            ? item.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: item.frontEndConfig.propsCheckStrictly
                            ? item.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        filterable
                        @change="
                          if (item.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[item.valueOption + 'Cascade'] &&
                              $refs[item.valueOption + 'Cascade'][0]
                            ) {
                              $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          if (formData.subdistrict) {
                            formData.subdistrict = '';
                          }
                          osg.getSubdistricts(formData.area, result => {
                            options.subdistricts = result;
                            $forceUpdate();
                          });
                          scriptToCalculate(item, formData);
                        "
                        collapse-tags
                      ></el-cascader>
                    </template>
                  </template>
                  <!-- 手机号码 -->
                  <!-- <template v-else-if="item.type == 'phone'">
                  <template v-if="item.preset">
                    <el-input
                      v-model="formData[item.name]"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? formData._id
                            ? true
                            : false
                          : false
                      "
                      :placeholder="item.placeholder || '请输入'"
                    ></el-input>
                  </template>
                  <template v-else>
                    <el-input
                      v-model="formData.exts[item.name]"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? formData._id
                            ? true
                            : false
                          : false
                      "
                      :placeholder="item.placeholder || '请输入'"
                    ></el-input>
                  </template>
                </template> -->
                  <!-- 产品选择器 -->
                  <template v-else-if="item.type == 'quote'">
                    <template>
                      <el-button type="primary" @click="getProduct(item)" class="c-m-b-10">
                        选择产品
                      </el-button>
                      <el-table :data="formData[item.name]" style="width: 100%">
                        <el-table-column
                          prop="name"
                          label="名称"
                          show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column prop="code" label="编号"></el-table-column>
                        <el-table-column
                          prop="productType"
                          label="分类"
                          :formatter="formatProductType"
                        ></el-table-column>
                        <el-table-column
                          label="成本价"
                          width="100px"
                          v-if="item.frontEndConfig.cost"
                        >
                          <template slot-scope="scope">
                            ¥ {{ scope.row.cost }}
                          </template>
                        </el-table-column>
                        <el-table-column label="单价" width="100px">
                          <template slot-scope="scope">
                            ¥ {{ scope.row.price }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="number" label="数量" width="153px">
                          <template slot-scope="scope">
                            <el-input-number
                              v-model="scope.row.number"
                              :min="0"
                              :precision="1"
                              size="mini"
                              @change="numChange(item)"
                            ></el-input-number>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="unit"
                          label="单位"
                          width="50px"
                          :formatter="formatUnit"
                        ></el-table-column>
                        <el-table-column label="小计" width="100px">
                          <template slot-scope="scope">
                            ¥
                            {{
                              parseFloat(
                                (Number(scope.row.price) * Number(scope.row.number || 0)).toFixed(2)
                              )
                            }}
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100px">
                          <template slot-scope="scope">
                            <el-button type="text" @click="removeProduct(item, scope.$index)">
                              删除
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </template>
                  <!-- 出入库选择器 -->
                  <template v-else-if="item.type == 'inventoryItem'">
                    <inventory :field="item" :formData="formData" :options="options"></inventory>
                  </template>
                </template>
              </el-form-item>
            </template>
            <template v-else-if="item.type == 'gap'">
              <!-- gap分隔槽 -->
              <div
                v-if="item.frontEndConfig && item.frontEndConfig.html"
                v-html="item.frontEndConfig && item.frontEndConfig.html"
                :key="i"
              ></div>
              <div v-else :key="i" class="c-form-gap"></div>
            </template>
            <template v-else>
              <el-form-item
                :class="
                  (currentNode
                    ? currentNode.nodeDef.formFieldIdsReadOnly.indexOf(item._id) != -1 &&
                      (item.type == 'request'
                        ? item.frontEndConfig.componentType == 'table'
                          ? false
                          : true
                        : true)
                      ? 'c-no-pointer ' + item.class
                      : item.class || ''
                    : item.class || '') + ` c-form-item-${item.type}`
                "
                :key="i"
                :label="'name' in item.frontEndConfig ? item.frontEndConfig.name : item.nameDisp"
                :label-width="item.frontEndConfig.labelWidth || labelWidth"
                :prop="item.preset ? item.name : 'exts.' + item.name"
                :rules="{
                  required:
                    item.required == '1'
                      ? item.frontEndConfig.privateNumber && formData._id
                        ? false
                        : currentNode
                        ? currentNode.nodeDef.formFieldIdsReadOnly.indexOf(item._id) != -1
                          ? false
                          : true
                        : true
                      : false,
                  pattern:
                    item.type == 'phone' &&
                    (item.preset ? formData[item.name] : formData.exts[item.name]) &&
                    (item.frontEndConfig.privateNumber ? (formData._id ? false : true) : true)
                      ? /^(1[3-9]{1}\d{9}|0\d{2,3}\d{7,8}|400[0-9]{7}|800[0-9]{7})$/
                      : /^([\s\S]*)$/,
                  trigger: ['change', 'blur'],
                  message: item.type == 'phone' ? '格式不正确' : '不能为空'
                }"
              >
                <template v-if="attrsCustomizeList.includes(item.name)">
                  <template v-for="attr in attrsCustomizeList">
                    <slot :name="attr" v-if="attr == item.name" :item="item"></slot>
                  </template>
                </template>
                <template v-else>
                  <!-- 展示计算后的值 -->
                  <template
                    v-if="item.type == 'compute' && osg.renderCompute(item.frontEndConfig.formula)"
                  >
                    <span>{{ osg.renderCompute(item.frontEndConfig.formula) }}</span>
                  </template>
                  <!-- 仅展示：不使用组件，防止F12修改表单值 -->
                  <template v-else-if="item.type == 'onlyShow'">
                    <span>
                      {{
                        item.preset
                          ? Array.isArray(formData[item.name])
                            ? formData[item.name].join('、')
                            : formData[item.name]
                          : Array.isArray(formData.exts[item.name])
                          ? formData.exts[item.name].join('、')
                          : formData.exts[item.name]
                      }}
                    </span>
                  </template>
                  <!-- 单选 -->
                  <template v-else-if="item.type == 'radio'">
                    <template v-if="item.preset">
                      <el-radio-group
                        v-model="formData[item.name]"
                        class="c-flex"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        @change="scriptToCalculate(item, formData)"
                      >
                        <el-radio
                          v-for="opt in options[item.valueOption]"
                          :label="
                            item.frontEndConfig.fieldType == 'number' || item.frontEndConfig.number
                              ? Number(opt.value)
                              : opt.value
                          "
                          :key="opt._id || opt.value"
                        >
                          {{ opt.label }}
                        </el-radio>
                      </el-radio-group>
                    </template>
                    <template v-else>
                      <el-radio-group
                        v-model="formData.exts[item.name]"
                        class="c-flex"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        @change="scriptToCalculate(item, formData)"
                      >
                        <el-radio
                          v-for="opt in options[item.valueOption]"
                          :label="
                            item.frontEndConfig.fieldType == 'number' || item.frontEndConfig.number
                              ? Number(opt.value)
                              : opt.value
                          "
                          :key="opt._id || opt.value"
                        >
                          {{ opt.label }}
                        </el-radio>
                      </el-radio-group>
                    </template>
                  </template>
                  <!-- 多选 -->
                  <template v-else-if="item.type == 'checkbox'" @change="$forceUpdate()">
                    <template v-if="item.preset">
                      <el-checkbox-group v-model="formData[item.name]" @change="$forceUpdate()">
                        <el-checkbox
                          v-for="item in options[item.valueOption]"
                          :label="item.value"
                          :key="item._id || item.value"
                        >
                          {{ item.label }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </template>
                    <template v-else>
                      <el-checkbox-group
                        v-model="formData.exts[item.name]"
                        @change="$forceUpdate()"
                      >
                        <el-checkbox
                          v-for="item in options[item.valueOption]"
                          :label="item.value"
                          :key="item._id || item.value"
                        >
                          {{ item.label }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </template>
                  </template>
                  <!-- 下拉 -->
                  <template v-else-if="item.type == 'select'">
                    <template v-if="item.preset">
                      <el-select
                        v-model="formData[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        :multiple="item.multiple"
                        filterable
                        :allow-create="item.frontEndConfig.allowCreate"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        @change="scriptToCalculate(item, formData)"
                      >
                        <el-option
                          v-for="opt in options[item.valueOption]"
                          :key="opt._id || opt.value"
                          :label="opt.label"
                          :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="formData.exts[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        :multiple="item.multiple"
                        filterable
                        :allow-create="item.frontEndConfig.allowCreate"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        @change="scriptToCalculate(item, formData)"
                      >
                        <el-option
                          v-for="opt in options[item.valueOption]"
                          :key="opt._id || opt.value"
                          :label="opt.label"
                          :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </template>
                  <!-- 业务对象版下拉 -->
                  <template v-else-if="item.type == 'bizSelect'">
                    <template v-if="item.preset">
                      <el-select
                        v-model="formData[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        filterable
                        :allow-create="item.frontEndConfig.allowCreate"
                        :remote="item.frontEndConfig.remote ? true : false"
                        :remote-method="
                          query => {
                            return bizSelectRemote(query, item);
                          }
                        "
                        :reserve-keyword="item.frontEndConfig.remote && item.multiple"
                        :multiple="item.multiple"
                        @change="
                          value => {
                            return bizSelectChange(item, value);
                          }
                        "
                        @focus="
                          value => {
                            return bizSelectFocus(item, value);
                          }
                        "
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        class="biz-select"
                      >
                        <i class="el-icon-search" slot="prefix" style="width: 25px"></i>
                        <el-option
                          v-for="item in options[item.valueOption]"
                          :key="item._id || item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="formData.exts[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        filterable
                        :allow-create="item.frontEndConfig.allowCreate"
                        :remote="item.frontEndConfig.remote ? true : false"
                        :remote-method="
                          query => {
                            return bizSelectRemote(query, item);
                          }
                        "
                        :reserve-keyword="item.frontEndConfig.remote && item.multiple"
                        :multiple="item.multiple"
                        @change="
                          value => {
                            return bizSelectChange(item, value);
                          }
                        "
                        @focus="
                          value => {
                            return bizSelectFocus(item, value);
                          }
                        "
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        class="biz-select"
                      >
                        <i class="el-icon-search" slot="prefix" style="width: 25px"></i>
                        <el-option
                          v-for="item in options[item.valueOption || item.name]"
                          :key="item._id || item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </template>
                  <!-- 参照-字段值非数组 -->
                  <template v-else-if="item.type == 'request'">
                    <!-- 参照-单选 -->
                    <template v-if="item.frontEndConfig.componentType == 'radio'">
                      <template v-if="item.preset">
                        <el-radio-group
                          v-model="formData[item.name]"
                          class="c-flex c-flex-wrap"
                          @change="scriptToCalculate(item, formData)"
                        >
                          <el-radio
                            v-for="opt in options[item.valueOption]"
                            :label="
                              item.frontEndConfig.fieldType == 'number' ||
                              item.frontEndConfig.number
                                ? Number(opt.value)
                                : opt.value
                            "
                            :key="opt._id || opt.value"
                          >
                            {{ opt.label }}
                          </el-radio>
                        </el-radio-group>
                      </template>
                      <template v-else>
                        <el-radio-group
                          v-model="formData.exts[item.name]"
                          class="c-flex c-flex-wrap"
                          @change="scriptToCalculate(item, formData)"
                        >
                          <el-radio
                            v-for="opt in options[item.valueOption]"
                            :label="
                              item.frontEndConfig.fieldType == 'number' ||
                              item.frontEndConfig.number
                                ? Number(opt.value)
                                : opt.value
                            "
                            :key="opt._id || opt.value"
                          >
                            {{ opt.label }}
                          </el-radio>
                        </el-radio-group>
                      </template>
                    </template>
                    <!-- 参照-多选 -->
                    <!-- <template
                        v-else-if="item.frontEndConfig.componentType == 'checkbox'"
                        @change="$forceUpdate()"
                      >
                        <template v-if="item.preset">
                          <el-checkbox-group v-model="formData[item.name]" @change="$forceUpdate()">
                            <el-checkbox
                              v-for="item in options[item.valueOption]"
                              :label="item.value"
                              :key="item._id || item.value"
                            >
                              {{ item.label }}
                            </el-checkbox>
                          </el-checkbox-group>
                        </template>
                        <template v-else>
                          <el-checkbox-group
                            v-model="formData.exts[item.name]"
                            @change="$forceUpdate()"
                          >
                            <el-checkbox
                              v-for="item in options[item.valueOption]"
                              :label="item.value"
                              :key="item._id || item.value"
                            >
                              {{ item.label }}{{ item.value }}
                            </el-checkbox>
                          </el-checkbox-group>
                        </template>
                      </template> -->
                    <!-- 参照-下拉 -->
                    <template v-if="item.frontEndConfig.componentType == 'select'">
                      <template v-if="item.preset">
                        <el-select
                          v-model="formData[item.name]"
                          :placeholder="item.placeholder || '请选择'"
                          clearable
                          filterable
                          :allow-create="item.frontEndConfig.allowCreate"
                          :remote="item.frontEndConfig.remote ? true : false"
                          :remote-method="
                            query => {
                              return bizSelectRemote(query, item);
                            }
                          "
                          :reserve-keyword="item.frontEndConfig.remote && item.multiple"
                          :multiple="item.multiple"
                          @change="
                            value => {
                              return bizSelectChange(item, value);
                            }
                          "
                          @focus="
                            value => {
                              return bizSelectFocus(item, value);
                            }
                          "
                          :disabled="
                            item.operationType == '2'
                              ? true
                              : item.operationType == '3'
                              ? formData._id
                                ? true
                                : false
                              : false
                          "
                        >
                          <el-option
                            v-for="item in options[item.valueOption]"
                            :key="item._id || item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </template>
                      <template v-else>
                        <el-select
                          v-model="formData.exts[item.name]"
                          :placeholder="item.placeholder || '请选择'"
                          clearable
                          filterable
                          :allow-create="item.frontEndConfig.allowCreate"
                          :remote="item.frontEndConfig.remote ? true : false"
                          :remote-method="
                            query => {
                              return bizSelectRemote(query, item);
                            }
                          "
                          :reserve-keyword="item.frontEndConfig.remote && item.multiple"
                          :multiple="item.multiple"
                          @change="
                            value => {
                              return bizSelectChange(item, value);
                            }
                          "
                          @focus="
                            value => {
                              return bizSelectFocus(item, value);
                            }
                          "
                          :disabled="
                            item.operationType == '2'
                              ? true
                              : item.operationType == '3'
                              ? formData._id
                                ? true
                                : false
                              : false
                          "
                        >
                          <el-option
                            v-for="item in options[item.valueOption]"
                            :key="item._id || item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </template>
                    </template>
                  </template>
                  <!-- 级联 -->
                  <template v-else-if="item.type == 'cascade'">
                    <template v-if="item.preset">
                      <el-cascader
                        :placeholder="item.placeholder || '请选择'"
                        :popper-class="
                          item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                        "
                        :ref="item.valueOption + 'Cascade'"
                        v-model="formData[item.name]"
                        :options="options[item.valueOption]"
                        :props="{
                          emitPath: item.frontEndConfig.emitPath == false ? false : true,
                          multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                          label: item.frontEndConfig.label || 'name',
                          value: item.frontEndConfig.value || 'value',
                          children: item.frontEndConfig.children || 'children',
                          expandTrigger: item.frontEndConfig.propsExpandTrigger
                            ? item.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: item.frontEndConfig.propsCheckStrictly
                            ? item.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        filterable
                        @change="
                          if (item.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[item.valueOption + 'Cascade'] &&
                              $refs[item.valueOption + 'Cascade'][0]
                            ) {
                              $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          $forceUpdate();
                        "
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                      ></el-cascader>
                    </template>
                    <template v-else>
                      <el-cascader
                        :placeholder="item.placeholder || '请选择'"
                        :popper-class="
                          item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                        "
                        :ref="item.valueOption + 'Cascade'"
                        v-model="formData.exts[item.name]"
                        :options="options[item.valueOption]"
                        :props="{
                          emitPath: item.frontEndConfig.emitPath == false ? false : true,
                          multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                          label: 'name',
                          expandTrigger: item.frontEndConfig.propsExpandTrigger
                            ? item.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: item.frontEndConfig.propsCheckStrictly
                            ? item.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        filterable
                        @change="
                          if (item.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[item.valueOption + 'Cascade'] &&
                              $refs[item.valueOption + 'Cascade'][0]
                            ) {
                              $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          $forceUpdate();
                        "
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                      ></el-cascader>
                    </template>
                  </template>
                  <!-- 日期 日期时间 -->
                  <template
                    v-else-if="
                      item.type == 'date' ||
                        item.type == 'datetime' ||
                        item.type == 'daterange' ||
                        item.type == 'datetimerange'
                    "
                  >
                    <template v-if="item.preset">
                      <el-date-picker
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        v-model="formData[item.name]"
                        :value-format="
                          item.type == 'date' || item.type == 'daterange'
                            ? 'yyyy-MM-dd'
                            : 'yyyy-MM-dd HH:mm:ss'
                        "
                        :default-time="
                          item.type == 'daterange' || item.type == 'datetimerange'
                            ? ['00:00:00', '23:59:59']
                            : '00:00:00'
                        "
                        :type="item.type"
                        :placeholder="item.placeholder || '请选择日期'"
                        @change="scriptToCalculate(item, formData)"
                      ></el-date-picker>
                    </template>
                    <template v-else>
                      <el-date-picker
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        v-model="formData.exts[item.name]"
                        :value-format="item.type == 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'"
                        :default-time="
                          item.type == 'daterange' || item.type == 'datetimerange'
                            ? ['00:00:00', '23:59:59']
                            : '00:00:00'
                        "
                        :type="item.type"
                        :placeholder="item.placeholder || '请选择日期'"
                      ></el-date-picker>
                    </template>
                  </template>
                  <!-- 时间 -->
                  <template v-else-if="item.type == 'time'">
                    <template v-if="item.preset">
                      <el-time-picker
                        v-model="formData[item.name]"
                        value-format="HH:mm:ss"
                        :placeholder="item.placeholder || '请选择时间'"
                      ></el-time-picker>
                    </template>
                    <template v-else>
                      <el-time-picker
                        v-model="formData.exts[item.name]"
                        value-format="HH:mm:ss"
                        :placeholder="item.placeholder || '请选择时间'"
                      ></el-time-picker>
                    </template>
                  </template>
                  <!-- 上传文件 -->
                  <template v-else-if="item.type == 'file'">
                    <el-upload
                      :class="{
                        'c-upload-maxLimit': item.preset
                          ? formData[item.name] &&
                            formData[item.name].length >= item.frontEndConfig.max
                          : formData.exts[item.name] &&
                            formData.exts[item.name].length >= item.frontEndConfig.max
                      }"
                      :action="upload.url"
                      :data="upload.data"
                      :file-list="item.preset ? formData[item.name] : formData.exts[item.name]"
                      :multiple="item.frontEndConfig.multiple || true"
                      :list-type="item.frontEndConfig.listType || 'picture-card'"
                      :limit="item.frontEndConfig.limit || 10"
                      :on-exceed="osg.uploadExceed"
                      :before-remove="beforeRemoveCon"
                      :before-upload="
                        file => {
                          return osg.beforeUpload(file, item.frontEndConfig.fileType);
                        }
                      "
                      :on-success="
                        (response, file, fileList) => {
                          return uploadSuccess(
                            response,
                            file,
                            fileList,
                            item.preset
                              ? formName + '.' + item.name
                              : formName + '.exts.' + item.name,
                            false
                          );
                        }
                      "
                      :on-error="osg.uploadError"
                      :on-remove="
                        (file, fileList) => {
                          return beforeRemove(
                            file,
                            fileList,
                            item.preset
                              ? formName + '.' + item.name
                              : formName + '.exts.' + item.name,
                            false
                          );
                        }
                      "
                      :on-preview="osg.uploadPreview"
                    >
                      <el-button
                        icon="el-icon-plus"
                        round
                        v-if="item.frontEndConfig.listType == 'text'"
                      >
                        点击上传
                      </el-button>
                      <i class="el-icon-plus" v-else></i>
                      <div
                        slot="file"
                        slot-scope="{ file, fileList }"
                        v-if="
                          osg.videoFormat.indexOf(
                            file.name.split('.')[file.name.split('.').length - 1].toLowerCase()
                          ) != -1
                        "
                        style="width: 100%; height: 100%"
                      >
                        <span class="el-upload-list__item-actions" style="z-index: 100">
                          <span
                            class="el-upload-list__item-preview"
                            @click="osg.uploadPreview(file)"
                          >
                            <i class="el-icon-video-play"></i>
                          </span>

                          <span
                            class="el-upload-list__item-delete"
                            @click="
                              beforeRemove(
                                file,
                                fileList,
                                item.preset
                                  ? formName + '.' + item.name
                                  : formName + '.exts.' + item.name,
                                false
                              )
                            "
                          >
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>

                        <video
                          style="width: 100%; height: 100%; object-fit: fill; border-radius: 0"
                          :src="file.url"
                          class="avatar"
                          controls="controls"
                        >
                          您的浏览器不支持视频播放
                        </video>
                      </div>
                    </el-upload>
                    <el-dialog
                      :modal="false"
                      custom-class="dialog-img"
                      :visible.sync="upload.dialogVisible"
                    >
                      <img width="100%" :src="upload.dialogImageUrl" />
                    </el-dialog>
                  </template>
                  <!-- 开关 -->
                  <template v-else-if="item.type == 'switch'">
                    <template v-if="item.preset">
                      <el-switch
                        v-model="formData[item.name]"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0"
                      ></el-switch>
                    </template>
                    <template v-else>
                      <el-switch
                        v-model="formData.exts[item.name]"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0"
                      ></el-switch>
                    </template>
                  </template>
                  <!-- 评分 -->
                  <template v-else-if="item.type == 'rate'">
                    <template v-if="item.preset">
                      <el-rate v-model="formData[item.name]" @change="$forceUpdate()"></el-rate>
                    </template>
                    <template v-else>
                      <el-rate
                        v-model="formData.exts[item.name]"
                        @change="$forceUpdate()"
                      ></el-rate>
                    </template>
                  </template>
                  <!-- 省市区 -->
                  <template v-else-if="item.type == 'area'">
                    <template v-if="item.preset">
                      <el-cascader
                        :placeholder="item.placeholder || '请选择'"
                        :popper-class="
                          item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                        "
                        ref="area"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        v-model="formData[item.name]"
                        :options="area.options"
                        :props="{
                          emitPath: item.frontEndConfig.emitPath == false ? false : true,
                          multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                          label: item.frontEndConfig.label ? item.frontEndConfig.label : 'label',
                          expandTrigger: item.frontEndConfig.propsExpandTrigger
                            ? item.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: item.frontEndConfig.propsCheckStrictly
                            ? item.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        filterable
                        @change="
                          if (item.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[item.valueOption + 'Cascade'] &&
                              $refs[item.valueOption + 'Cascade'][0]
                            ) {
                              $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          if (formData.subdistrict) {
                            formData.subdistrict = '';
                          }
                          osg.getSubdistricts(formData.area, result => {
                            options.subdistricts = result;
                            $forceUpdate();
                          });
                        "
                      ></el-cascader>
                    </template>
                    <template v-else>
                      <el-cascader
                        :placeholder="item.placeholder || '请选择'"
                        :popper-class="
                          item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                        "
                        ref="area"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        v-model="formData.exts[item.name]"
                        :options="area.options"
                        :props="{
                          emitPath: item.frontEndConfig.emitPath == false ? false : true,
                          multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                          label: item.frontEndConfig.label ? item.frontEndConfig.label : 'label',
                          expandTrigger: item.frontEndConfig.propsExpandTrigger
                            ? item.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: item.frontEndConfig.propsCheckStrictly
                            ? item.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        filterable
                        @change="
                          if (item.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[item.valueOption + 'Cascade'] &&
                              $refs[item.valueOption + 'Cascade'][0]
                            ) {
                              $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          if (formData.subdistrict) {
                            formData.subdistrict = '';
                          }
                          osg.getSubdistricts(formData.area, result => {
                            options.subdistricts = result;
                            $forceUpdate();
                          });
                        "
                      ></el-cascader>
                    </template>
                  </template>
                  <!-- 手机 -->
                  <template v-else-if="item.type == 'phone'">
                    <template v-if="item.preset">
                      <el-input
                        v-model.trim="formData[item.name]"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        :placeholder="item.placeholder || '请输入'"
                      >
                        <el-button
                          slot="append"
                          icon="el-icon-plus"
                          class="bg_blue c_white"
                          style="border-radius:0 4px 4px 0;display:flex;height:32px;"
                          v-if="item.frontEndConfig.creatable"
                          @click="phoneAdd(item)"
                        ></el-button>
                      </el-input>
                      <template v-if="formData.exts[item.name + 'List']">
                        <el-card
                          class="phone-card"
                          shadow="hover"
                          v-for="(phoneMap, j) in formData.exts[item.name + 'List']"
                          :key="j"
                        >
                          <el-form-item
                            label="关系"
                            label-width="60px"
                            :prop="`exts.${item.name + 'List'}.${j}.relation`"
                            :rules="{
                              required: true,
                              trigger: 'change',
                              message: '请选择联系人关系'
                            }"
                          >
                            <el-select
                              v-model="formData.exts[item.name + 'List'][j].relation"
                              placeholder="请选择联系人关系"
                              class="relation"
                            >
                              <el-option
                                v-for="opt in options.contactRelation"
                                :key="opt._id || opt.value"
                                :label="opt.label"
                                :value="opt.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            label="姓名"
                            label-width="60px"
                            :prop="`exts.${item.name + 'List'}.${j}.name`"
                            :rules="{
                              required: true,
                              trigger: ['blur', 'change'],
                              message: '请输入姓名'
                            }"
                          >
                            <el-input
                              v-model.trim="formData.exts[item.name + 'List'][j].name"
                              placeholder="请输入姓名"
                              class="name"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            label="手机"
                            label-width="60px"
                            :prop="`exts.${item.name + 'List'}.${j}.phone`"
                            :rules="{
                              required: true,
                              pattern: /^(1[3-9]{1}\d{9}|0\d{2,3}\d{7,8}|400[0-9]{7}|800[0-9]{7})$/,
                              trigger: ['blur', 'change'],
                              message: '请输入正确格式的号码'
                            }"
                          >
                            <el-input
                              v-model.trim="formData.exts[item.name + 'List'][j].phone"
                              placeholder="请输入电话"
                              class="phone"
                              @blur="phoneBlur(formData.exts[item.name + 'List'][j].phone, j)"
                            ></el-input>
                          </el-form-item>
                          <div class="c-flex c-flex-between">
                            <el-button
                              type="primary"
                              plain
                              size="small"
                              style="margin-left:0;"
                              v-if="!formData.exts[item.name + 'List'][j].default"
                              @click="phoneSetDefault(item, j)"
                            >
                              设为默认联系人
                            </el-button>
                            <div v-else>
                              <el-button
                                type="success"
                                plain
                                size="small"
                                style="margin-left:0;"
                                icon="el-icon-phone"
                                @click="phoneCancelDefault(item, j)"
                              >
                                取消默认联系人
                              </el-button>
                            </div>
                            <el-button plain size="small" @click="phoneRemove(item, j)">
                              删除
                            </el-button>
                          </div>
                        </el-card>
                      </template>
                    </template>
                    <template v-else>
                      <el-input
                        v-model.trim="formData.exts[item.name]"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        :placeholder="item.placeholder || '请输入'"
                      ></el-input>
                    </template>
                  </template>
                  <!-- 产品选择器 -->
                  <template v-else-if="item.type == 'quote'">
                    <template>
                      <el-button type="primary" @click="getProduct(item)" class="c-m-b-10">
                        选择产品
                      </el-button>
                      <el-table :data="formData[item.name]" style="width: 100%">
                        <el-table-column
                          prop="name"
                          label="名称"
                          show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column prop="code" label="编号"></el-table-column>
                        <el-table-column
                          prop="productType"
                          label="分类"
                          :formatter="formatProductType"
                        ></el-table-column>
                        <el-table-column
                          label="成本价"
                          width="100px"
                          v-if="item.frontEndConfig.cost"
                        >
                          <template slot-scope="scope">
                            ¥ {{ scope.row.cost }}
                          </template>
                        </el-table-column>
                        <el-table-column label="单价" width="100px">
                          <template slot-scope="scope">
                            ¥ {{ scope.row.price }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="number" label="数量" width="153px">
                          <template slot-scope="scope">
                            <el-input-number
                              v-model="scope.row.number"
                              :min="0"
                              :precision="1"
                              size="mini"
                              @change="numChange(item)"
                            ></el-input-number>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="unit"
                          label="单位"
                          width="50px"
                          :formatter="formatUnit"
                        ></el-table-column>
                        <el-table-column label="小计" width="100px">
                          <template slot-scope="scope">
                            ¥
                            {{
                              parseFloat(
                                (Number(scope.row.price) * Number(scope.row.number || 0)).toFixed(2)
                              )
                            }}
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100px">
                          <template slot-scope="scope">
                            <el-button type="text" @click="removeProduct(item, scope.$index)">
                              删除
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </template>
                  <!-- 出入库选择器 -->
                  <template v-else-if="item.type == 'inventoryItem'">
                    <inventory :field="item" :formData="formData" :options="options"></inventory>
                  </template>
                  <!-- 关联工单编号 -->
                  <template
                    v-else-if="
                      item.name == 'sourceSADatas' &&
                        (formData.sourceSADatas || (formData.exts && formData.exts.sourceSADatas))
                    "
                  >
                    <div v-for="(data, index) of formData.exts.sourceSADatas" :key="index">
                      <div
                        class="c_blue c_size_12 c_pointer"
                        style="line-height:20px;margin-bottom:10px"
                        @click="osg.open('', '', '_blank', '/Flow/serviceAppointment/' + data._id)"
                      >
                        {{ data.title }}：{{ data.code }}
                        <i
                          class="el-icon-circle-close c_red c-m-l-10"
                          @click.stop="
                            () => {
                              osg.confirm('是否确认取消关联', () => {
                                formData.exts.sourceSADatas.splice(index, 1);
                              });
                            }
                          "
                        ></i>
                      </div>
                    </div>
                  </template>
                  <!-- 文本 文本域 数字 -->
                  <template
                    v-else-if="
                      item.type == 'text' ||
                        item.type == 'textarea' ||
                        item.type == 'number' ||
                        item.type == 'digit'
                    "
                  >
                    <template v-if="item.preset">
                      <el-input-number
                        :controls="false"
                        v-if="item.type == 'digit' || item.type == 'number'"
                        v-model="formData[item.name]"
                        :precision="item.frontEndConfig.precision"
                        :min="item.frontEndConfig.min || -Infinity"
                        :max="item.frontEndConfig.max || Infinity"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        :type="item.type"
                        :placeholder="item.placeholder || '请输入'"
                        @blur="scriptToCalculate(item, formData)"
                      ></el-input-number>
                      <el-input
                        v-else
                        v-model.trim="formData[item.name]"
                        :autosize="{ minRows: 1, maxRows: 5 }"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        :type="item.type"
                        :rows="item.rows || 1"
                        :placeholder="item.placeholder || '请输入'"
                        :clearable="item.type == 'textarea' ? true : false"
                        @blur="scriptToCalculate(item, formData)"
                        :maxlength="item.frontEndConfig.maxlength || null"
                        :show-word-limit="item.frontEndConfig.maxlength ? true : false"
                      >
                        <el-button
                          slot="append"
                          v-if="
                            item.calculateConfig &&
                              item.calculateConfig.trigger == 'appendButton' &&
                              (item.calculateConfig.scriptId || item.calculateConfig.groovyScriptId)
                          "
                          @click="scriptToCalculate(item, formData, 'append')"
                        >
                          {{ item.calculateConfig.triggerName || '点击执行' }}
                        </el-button>
                      </el-input>
                    </template>
                    <template v-else>
                      <el-input-number
                        :controls="false"
                        v-if="item.type == 'digit' || item.type == 'number'"
                        v-model="formData.exts[item.name]"
                        :precision="item.frontEndConfig.precision"
                        :min="item.frontEndConfig.min || -Infinity"
                        :max="item.frontEndConfig.max || Infinity"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        :type="item.type"
                        :rows="item.rows || 1"
                        :placeholder="item.placeholder || '请输入'"
                        :clearable="item.type == 'textarea' ? true : false"
                        @blur="scriptToCalculate(item, formData)"
                      ></el-input-number>
                      <el-input
                        v-else
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        v-model.trim="formData.exts[item.name]"
                        :type="item.type"
                        :placeholder="item.placeholder || '请输入'"
                        @blur="scriptToCalculate(item, formData)"
                        :maxlength="item.frontEndConfig.maxlength || null"
                        :show-word-limit="item.frontEndConfig.maxlength ? true : false"
                      >
                        <el-button
                          slot="append"
                          v-if="
                            item.calculateConfig &&
                              item.calculateConfig.trigger == 'appendButton' &&
                              (item.calculateConfig.scriptId || item.calculateConfig.groovyScriptId)
                          "
                          @click="scriptToCalculate(item, formData)"
                        >
                          {{ item.calculateConfig.triggerName || '点击执行' }}
                        </el-button>
                      </el-input>
                    </template>
                  </template>
                  <!-- 富文本 -->
                  <template v-else-if="item.type == 'richText'">
                    <template v-if="item.preset">
                      <c-editor :formData="formData" :value="item.name" ref="editor"></c-editor>
                    </template>
                    <template v-else>
                      <c-editor
                        :formData="formData"
                        :value="'exts.' + item.name"
                        ref="editor"
                      ></c-editor>
                    </template>
                  </template>
                  <!-- 预览文件 -->
                  <template v-else-if="item.type == 'download'">
                    <template v-if="item.preset">
                      <el-link :href="formData[item.name]" type="primary" target="_blank">
                        {{ formData[item.name] }}
                      </el-link>
                    </template>
                    <template v-else>
                      <el-link :href="formData.exts[item.name]" type="primary" target="_blank">
                        {{ formData.exts[item.name] }}
                      </el-link>
                    </template>
                  </template>
                  <template v-else-if="item.type == 'canvas'">
                    <template v-if="item.preset">
                      <el-image
                        v-if="formData[item.name]"
                        :src="formData[item.name]"
                        fit="contain"
                      ></el-image>
                    </template>
                    <template v-else>
                      <el-image
                        v-if="formData.exts[item.name]"
                        :src="formData.exts[item.name]"
                        fit="contain"
                      ></el-image>
                    </template>
                  </template>
                  <!-- 地点搜索更新地理编码 geocodePOI  -->
                  <template v-else-if="item.type == 'geocodePOI'">
                    <template v-if="item.preset">
                      <el-autocomplete
                        v-model="formData[item.name]"
                        suffix-icon="el-icon-map-location"
                        :fetch-suggestions="osg.inputtips"
                        @select="osg.inputtipsSelect"
                        autosize
                        type="textarea"
                        :trigger-on-focus="false"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        :placeholder="item.placeholder || '请输入'"
                      >
                        <template slot-scope="{ item }">
                          <div class="c-flex">
                            <span>{{ item.name }}</span>
                            <span style="margin-left: 6px;color: #ccc;">
                              {{ item.district }}
                            </span>
                          </div>
                        </template>
                      </el-autocomplete>
                    </template>
                    <template v-else>
                      <el-autocomplete
                        v-model="formData.exts[item.name]"
                        suffix-icon="el-icon-map-location"
                        :fetch-suggestions="autoAddress"
                        @select="autoAddressSelect"
                        :trigger-on-focus="false"
                        autosize
                        type="textarea"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? formData._id
                              ? true
                              : false
                            : false
                        "
                        :placeholder="item.placeholder || '请输入'"
                      >
                        <template slot-scope="{ item }">
                          <div class="c-flex">
                            <span>{{ item.name }}</span>
                            <span style="margin-left: 6px;color: #ccc;">
                              {{ item.district }}
                            </span>
                          </div>
                        </template>
                      </el-autocomplete>
                    </template>
                  </template>
                  <!-- 超链接 -->
                  <template v-else-if="item.type == 'aLink'">
                    <el-link
                      v-if="item.preset"
                      style="font-size: 12px;"
                      :underline="false"
                      :href="formData[item.name]"
                      target="_blank"
                    >
                      {{ formData[item.name] }}
                    </el-link>
                    <el-link
                      v-else
                      style="font-size: 12px;"
                      :underline="false"
                      :href="formData.exts[item.name]"
                      target="_blank"
                    >
                      {{ formData.exts[item.name] }}
                    </el-link>
                  </template>
                  <!-- 数组 -->
                  <template v-else-if="item.type == 'data'">
                    <div>{{ formData[item.name] }}</div>
                    <!-- <el-link
                      v-else
                      style="font-size: 12px;"
                      :underline="false"
                      :href="formData.exts[item.name]"
                      target="_blank"
                    >
                      {{ formData.exts[item.name] }}
                    </el-link> -->
                  </template>
                  <!-- 代码 -->
                  <template v-else-if="item.type == 'code'">
                    <codemirror
                      :formData="formData"
                      :preset="item.preset"
                      :fieldName="item.name"
                    ></codemirror>
                  </template>
                  <!-- 标题 -->
                  <template v-else-if="item.type == 'title'">
                    <div v-html="item.frontEndConfig.html || formData[item.name]"></div>
                  </template>

                  <!-- 地图 -->
                  <template v-else-if="item.type == 'map'">
                    <div style="display: flex;">
                      <el-input
                        style="flex:1"
                        :placeholder="item.placeholder || '请输入'"
                        v-model="formData[item.name]"
                        class="map-selection-input"
                      ></el-input>
                      <el-button
                        type="primary"
                        icon="el-icon-position"
                        @click.native="openLocationPicker"
                        style="border-radius: 0 4px 4px 0;height:32px;"
                      >
                        地图选址
                      </el-button>
                    </div>
                  </template>
                </template>
              </el-form-item>
            </template>
          </template>
        </template>
      </template>
    </el-form>
    <!--选择产品-->
    <el-dialog
      title="产品"
      :visible.sync="product.open"
      class="c-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
    >
      <div>
        <el-input
          placeholder="请输入名称/编号"
          v-model.trim="product.searchValue"
          class="search-input c-fr"
          clearable
          @clear="
            product.fpi.page = 1;
            getProduct();
          "
          @keyup.enter.native="
            product.fpi.page = 1;
            getProduct();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              product.fpi.page = 1;
              getProduct();
            "
          ></el-button>
        </el-input>
      </div>
      <el-table
        :data="product.fpi.data"
        height="100%"
        style="width: 100%; min-height: 440px"
        fit
        header-row-class-name="c-black-dark"
        @selection-change="productSelect"
        empty-text="暂无未选择的产品"
      >
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column prop="name" label="名称" fixed></el-table-column>
        <el-table-column prop="code" label="编号"></el-table-column>
        <el-table-column
          prop="cost"
          label="成本价(元)"
          v-if="product.f.frontEndConfig && product.f.frontEndConfig.cost"
        ></el-table-column>
        <el-table-column prop="price" label="单价(元)"></el-table-column>
        <el-table-column prop="unit" label="单位" :formatter="formatUnit"></el-table-column>
        <el-table-column
          prop="productType"
          label="分类"
          :formatter="formatProductType"
        ></el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="product.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="product.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="product.fpi.total"
        ></el-pagination>
        <div>
          <el-button type="primary" @click="saveSelectProduct()">确 定</el-button>
          <el-button @click="cancelSelectProduct()">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!--选择参照-->
    <el-dialog
      :visible.sync="request.open"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      :class="fullscreen ? 'c-dialog-fullscreen' : ''"
    >
      <div slot="title" class="c-dialog-title">
        <div>添加{{ request.f.nameDisp }}</div>
        <i class="el-icon-full-screen" style="color:#909399" @click="$emit('screenChange')"></i>
      </div>
      <!-- <div>
        <el-input
          placeholder="请输入名称/编号"
          v-model.trim="request.searchValue"
          class="search-input c-fr"
          clearable
          @clear="
            request.fpi.page = 1;
            requestClick(request.f);
          "
          @keyup.enter.native="
            request.fpi.page = 1;
            requestClick(request.f);
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              request.fpi.page = 1;
              requestClick(request.f);
            "
          >
            搜索
          </el-button>
        </el-input>
      </div> -->
      <el-table
        ref="request"
        :data="requestOptions[request.fieldName]"
        width="100%"
        height="100%"
        fit
        header-row-class-name="c-black-dark"
        @selection-change="requestSelect"
        empty-text="暂无未选择的数据"
      >
        <c-table
          @setoptions="setOptions"
          :fields="options[(request.valueOption || request.fieldName) + 'Fields']"
          :options="requestOptions"
          :action="true"
          :selection="true"
        ></c-table>
        <!-- <el-table-column type="selection" width="55" fixed></el-table-column> -->
      </el-table>
      <div slot="footer">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="request.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="request.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="request.fpi.total"
        ></el-pagination>
        <div>
          <el-button type="primary" @click="saveSelectRequest()">确 定</el-button>
          <el-button @click="cancelSelectRequest()">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 操作按钮弹窗 -->
    <el-dialog
      custom-class="c-form-dialog"
      :visible.sync="action.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal="false"
      :class="fullscreen ? 'c-dialog-fullscreen' : ''"
    >
      <div slot="title" class="c-dialog-title" v-if="action.def.name">
        <div>{{ action.def.name }}</div>
        <i class="el-icon-full-screen" style="color:#909399" @click="$emit('screenChange')"></i>
      </div>
      <div
        v-if="
          action.fields.filter(field => {
            return field.showList.indexOf('10') != -1;
          }).length > 0
        "
      >
        <el-form :inline="true">
          <el-form-item
            :label="item.nameDisp"
            v-for="(item, i) of action.fields.filter(field => {
              return field.showList.indexOf('10') != -1;
            })"
            :key="i"
          >
            <template v-if="['select', 'radio', 'checkbox', 'bizSelect'].indexOf(item.type) != -1">
              <el-select
                v-model="action.filter[item.name]"
                :placeholder="item.placeholder || '请选择'"
                clearable
                :multiple="true"
                filterable
              >
                <template v-if="item.type == 'bizSelect'">
                  <el-option
                    v-for="opt in requestOptions[item.valueOption]"
                    :key="opt._id || opt.value"
                    :label="opt.label"
                    :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                  ></el-option>
                </template>
                <template v-else>
                  <el-option
                    v-for="opt in action.options[item.valueOption]"
                    :key="opt._id || opt.value"
                    :label="opt.label"
                    :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                  ></el-option>
                </template>
              </el-select>
            </template>
            <template v-else>
              <el-input
                :key="i"
                placeholder="请输入"
                v-model="action.filter[item.name]"
                clearable
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="
                action.fpi.page = 1;
                actionClick();
              "
            >
              查询
            </el-button>
            <el-button
              icon="el-icon-refresh"
              @click="
                action.fpi.page = 1;
                action.filter = {};
                actionClick();
              "
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="actionTable"
        :data="action.fpi.data"
        width="100%"
        height="calc(100% - 101px)"
        fit
        header-row-class-name="c-black-dark"
        @selection-change="actionSelect"
        empty-text="暂无未选择的数据"
      >
        <!-- <el-table-column type="selection" width="55" fixed></el-table-column> -->
        <c-table
          v-if="action.show"
          :fields="action.fields"
          :options="action.options"
          :listEditable="true"
          :action="true"
          :selection="true"
        ></c-table>
      </el-table>
      <div slot="footer" class="c-flex c-flex-item c-flex-between" style="padding:0;">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="action.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="action.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="action.fpi.total"
        ></el-pagination>
        <div>
          <el-button type="primary" @click="actionConfirm()">确 定</el-button>
          <el-button @click="actionCancel()">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!--编辑参照-->
    <el-dialog
      :visible.sync="requestForm.open"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      :class="fullscreen ? 'c-dialog-fullscreen' : ''"
    >
      <div slot="title" class="c-dialog-title">
        <div>编辑{{ requestForm.f.nameDisp }}</div>
        <i class="el-icon-full-screen" style="color:#909399" @click="$emit('screenChange')"></i>
      </div>
      <c-form
        style="margin:20px;"
        :formData="requestForm.formData"
        :fields="options[requestForm.fieldName + 'Fields']"
        :options="requestOptions"
        :requestOptions="requestOptions"
        ref="form"
        :upload="upload"
        labelWidth="100px"
        :area="area"
      ></c-form>
      <div slot="footer">
        <div></div>
        <el-button type="primary" @click="requestSave()">确 定</el-button>
        <!-- <el-button @click="requestCancel()">取 消</el-button> -->
      </div>
    </el-dialog>

    <!-- 地图选点 -->
    <el-dialog
      width="1000px"
      title="选择地址"
      :visible.sync="record.openMap"
      @close="closeLocationPicker"
      :modal="false"
    >
      <div style="width: 100%;">
        <el-form label-width="120px">
          <el-form-item label="请输入详细地址">
            <el-autocomplete
              ref="autocomplete"
              :fetch-suggestions="
                (queryString, callback) => {
                  osg.inputtips(queryString, callback, this);
                }
              "
              @select="item => handleInputtipsSelect(item)"
              @keydown.enter.native.prevent="handleEnterSelect"
              v-model="record.values"
            >
              <template slot-scope="{ item }">
                <div class="c-flex">
                  <span>{{ item.value }}</span>
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-form>
        <div id="container" style="width: 100%;height: 60vh;"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeLocationPicker">取 消</el-button>
        <el-button type="primary" @click="confirmAddress">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'; //引入地图

export default {
  props: {
    fullscreen: Boolean,
    inline: Boolean,
    disabled: Boolean,
    size: String,
    formData: Object,
    fields: Array,
    options: Object,
    // 参照表格选项
    requestOptions: {
      type: Object,
      default: () => ({})
    },
    area: {
      type: Object,
      default: () => ({
        options: window.$this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      })
    },
    upload: Object,
    currentNode: Object,
    formName: {
      type: String,
      default: 'formData'
    },
    refName: String,
    labelWidth: {
      type: String,
      default: '90px'
    },
    labelPosition: {
      type: String,
      default: 'left'
    }
  },
  components: {
    inventory: () => import('./inventory.vue'),
    codemirror: () => import('./codemirror')
  },
  data() {
    return {
      attrsCustomizeList: [], //自定义字段
      product: {
        fpi: {},
        searchValue: '',
        open: false,
        selectRows: [],
        f: {}
      },
      requestTable: {
        selectRows: []
      },
      request: {
        open: false,
        show: false,
        fieldName: '',
        fpi: {},
        searchValue: '',
        selectRows: [],
        f: {}
      },
      requestForm: {
        open: false,
        fieldName: '',
        fpi: {},
        searchValue: '',
        selectRows: [],
        f: {}
      },
      currentRole: this.$util.isJson(sessionStorage['currentRole'])
        ? JSON.parse(sessionStorage['currentRole'])
        : '',
      currentUserId: this.$util.isJson(sessionStorage['loginAccount'])
        ? JSON.parse(sessionStorage['loginAccount'])._id
        : '',
      tenantId: this.$util.isJson(sessionStorage['loginAccount'])
        ? JSON.parse(sessionStorage['loginAccount']).tenantId
        : '',
      phoneStripData: {}, //电话条数据
      formShow: true,
      // 当前点击操作按钮
      action: {
        def: {},
        field: {}, //主表字段
        filter: {},
        show: false,
        fields: [],
        options: {},
        fpi: { data: [] },
        selectRows: []
      },

      // 测试数据
      record: {
        openMap: false, //是否打地图选点弹窗
        mapMarker: null, //地图选点弹窗 标记点
        infowindow: {}, //地图选点 信息窗体
        // 定位事件比较长 容易失败 提前定位将经纬度存储为对象
        location: {
          latitude: null, // 纬度
          longitude: null // 经度
        },
        map: null, //地图的实例对象
        geocoder: {}, //定位实例
        values: '' //输入的内容
      }
    };
  },
  mounted() {
    //初始化自定义字段
    this.initAttrsCustomizeList(() => {});
    this.getBizOptions(this.fields, this.formData);
    // 赋值初始默认值
    if (!this.formData._id) {
      this.fields.map(item => {
        if (item.frontEndConfig.default) {
          if (item.preset == 1) {
            this.$set(this.formData, item.name, item.frontEndConfig.default);
          } else {
            this.$set(this.formData.exts, item.name, item.frontEndConfig.default);
          }
        }
      });
    }
  },
  methods: {
    //初始化自定义字段
    initAttrsCustomizeList(callback) {
      this.$nextTick(() => {
        if (this.$scopedSlots) for (let key in this.$scopedSlots) this.attrsCustomizeList.push(key);
        if (callback) callback();
      });
    },
    // 关联业务档案，默认查询1次，解决前20条没有数据可返显
    getBizOptions(fields, formData) {
      if (!formData._id) return;
      for (let item of fields) {
        if (item.type == 'bizSelect') {
          if (!item.frontEndConfig.url) continue;
          let params = item.frontEndConfig.params || {};
          let obj = {};
          if (params['_all']) continue; //查询全部数据的 不需要再次查询
          for (let key in params) {
            let val = params[key];
            if (!val && val != 0) continue;
            if (String(val).startsWith('$')) {
              val = val.substring(1);
              if (val.indexOf('.') != -1) {
                let val0 = val.split('.')[0];
                let val1 = val.split('.')[1];
                formData[val0] = formData[val0] || {};
                obj[key] = formData[val0][val1];
              } else {
                obj[key] = formData[val];
              }
            } else if (String(val).startsWith('#')) {
              obj[key] = null;
            }
          }

          // 将当前字段值加入查询条件，解决返显问题
          if (!formData[item.name]) continue;
          if (item.preset) {
            if (Array.isArray(formData[item.name])) {
              obj[`in:${item.frontEndConfig.value}|array#and`] = formData[item.name].join();
            } else {
              obj[`is:${item.frontEndConfig.value}|string#or`] = formData[item.name];
            }
          } else {
            formData.exts = formData.exts || {};
            if (Array.isArray(formData.exts[item.name])) {
              obj[`in:${item.frontEndConfig.value}|array#and`] = formData.exts[item.name].join();
            } else {
              obj[`is:${item.frontEndConfig.value}|string#or`] = formData.exts[item.name];
            }
          }
          // 请求数据作为选项
          if (item.frontEndConfig.url) {
            this.osg.ajax(
              item.frontEndConfig.url,
              Object.assign({}, params, obj),
              res => {
                console.log('res.data', res.data);
                if (item.frontEndConfig.url.indexOf('org/query.do') != -1) {
                  res.data.orgList.map(obj => {
                    obj.label =
                      item.frontEndConfig.label.indexOf('.') != -1
                        ? (obj[item.frontEndConfig.label.split('.')[0]] &&
                            obj[item.frontEndConfig.label.split('.')[0]][
                              item.frontEndConfig.label.split('.')[1]
                            ]) ||
                          obj.name
                        : obj[item.frontEndConfig.label] || obj.name;
                    obj.value =
                      item.frontEndConfig.value.indexOf('.') != -1
                        ? (obj[item.frontEndConfig.value.split('.')[0]] &&
                            obj[item.frontEndConfig.value.split('.')[0]][
                              item.frontEndConfig.value.split('.')[1]
                            ]) ||
                          obj.name
                        : obj[item.frontEndConfig.value] || obj._id;
                  });
                  if (res.data.orgList.length > 0) {
                    this.options[item.valueOption || item.name] =
                      this.options[item.valueOption || item.name] || [];
                    let arr = this.options[item.valueOption || item.name].filter(row => {
                      return row.value == res.data.orgList[0].value;
                    });
                    if (arr.length == 0)
                      this.options[item.valueOption || item.name].push(res.data.orgList[0]);
                  }
                } else {
                  res.data.map(obj => {
                    obj.label =
                      item.frontEndConfig.label.indexOf('.') != -1
                        ? (obj[item.frontEndConfig.label.split('.')[0]] &&
                            obj[item.frontEndConfig.label.split('.')[0]][
                              item.frontEndConfig.label.split('.')[1]
                            ]) ||
                          obj.name
                        : obj[item.frontEndConfig.label] || obj.name;
                    obj.value =
                      item.frontEndConfig.value.indexOf('.') != -1
                        ? (obj[item.frontEndConfig.value.split('.')[0]] &&
                            obj[item.frontEndConfig.value.split('.')[0]][
                              item.frontEndConfig.value.split('.')[1]
                            ]) ||
                          obj.name
                        : obj[item.frontEndConfig.value] || obj._id;
                  });

                  if (res.data.length > 0) {
                    this.options[item.valueOption || item.name] =
                      this.options[item.valueOption || item.name] || [];

                    for (let i = 0; i < res.data.length; i++) {
                      let arr = this.options[item.valueOption || item.name].filter(row => {
                        return row.value == res.data[i].value;
                      });
                      if (arr.length == 0)
                        this.options[item.valueOption || item.name].push(res.data[i]);
                    }
                  }
                }
                if (item.frontEndConfig.initRequest) {
                  let value = item.preset ? formData[item.name] : formData.exts[item.name];
                  value = value || (item.multiple ? [] : '');
                  this.bizSelectChange(item, value);
                }
                this.$forceUpdate();
              },
              {
                noload: true
              }
            );
          }
        }
      }
    },
    bizSelectFocus(item) {
      if (!item || !item.frontEndConfig || !item.frontEndConfig.focus) return;
      let formData = this.formData || { exts: {} };
      // 处理参数中的变量
      let params = item.frontEndConfig.params || {};
      let obj = {};
      for (let key in params) {
        let val = params[key];
        if (!val && val != 0) continue;
        if (String(val).startsWith('$')) {
          val = val.substring(1);
          if (val.indexOf('.') != -1) {
            let val0 = val.split('.')[0];
            let val1 = val.split('.')[1];
            formData[val0] = formData[val0] || {};
            obj[key] = Array.isArray(formData[val0][val1])
              ? formData[val0][val1].join()
              : formData[val0][val1];
          } else {
            obj[key] = Array.isArray(formData[val]) ? formData[val].join() : formData[val];
          }
        } else if (String(val).startsWith('#')) {
          obj[key] = null;
        }
      }

      // 请求数据作为选项
      if (item.frontEndConfig.url) {
        this.osg.ajax(
          item.frontEndConfig.url,
          Object.assign({}, params, obj),
          res => {
            if (item.frontEndConfig.url.indexOf('org/query.do') != -1) {
              res.data.orgList.map(obj => {
                obj.label =
                  item.frontEndConfig.label.indexOf('.') != -1
                    ? (obj[item.frontEndConfig.label.split('.')[0]] &&
                        obj[item.frontEndConfig.label.split('.')[0]][
                          item.frontEndConfig.label.split('.')[1]
                        ]) ||
                      obj.name
                    : obj[item.frontEndConfig.label] || obj.name;
                obj.value =
                  item.frontEndConfig.value.indexOf('.') != -1
                    ? (obj[item.frontEndConfig.value.split('.')[0]] &&
                        obj[item.frontEndConfig.value.split('.')[0]][
                          item.frontEndConfig.value.split('.')[1]
                        ]) ||
                      obj.name
                    : obj[item.frontEndConfig.value] || obj._id;
              });
            } else {
              res.data.map(obj => {
                obj.label =
                  item.frontEndConfig.label.indexOf('.') != -1
                    ? (obj[item.frontEndConfig.label.split('.')[0]] &&
                        obj[item.frontEndConfig.label.split('.')[0]][
                          item.frontEndConfig.label.split('.')[1]
                        ]) ||
                      obj.name
                    : obj[item.frontEndConfig.label] || obj.name;
                obj.value =
                  item.frontEndConfig.value.indexOf('.') != -1
                    ? (obj[item.frontEndConfig.value.split('.')[0]] &&
                        obj[item.frontEndConfig.value.split('.')[0]][
                          item.frontEndConfig.value.split('.')[1]
                        ]) ||
                      obj.name
                    : obj[item.frontEndConfig.value] || obj._id;
              });
            }
            if (item.frontEndConfig.url.indexOf('org/query.do') != -1) {
              this.$set(window.$this.options, item.valueOption, res.data.orgList);
            } else {
              this.$set(window.$this.options, item.valueOption, res.data);
              this.$emit('changeForm', this.formData);
            }
          },
          {
            noload: true
          }
        );
      }
    },
    bizSelectChange(f, value) {
      let { valueOption, name, preset, frontEndConfig, calculateConfig } = f;
      if (f.multiple && Array.isArray(value)) {
        // 关联业务档案-多选
        if (value.length > 0) {
          let label = '';
          let v = frontEndConfig.value;
          let rows = [];
          if (v.indexOf('.') != -1) {
            let v1 = v.split('.')[0];
            let v2 = v.split('.')[1];
            value.map(val => {
              if (Array.isArray(this.options[valueOption || name])) {
                this.options[valueOption || name].map(option => {
                  // 1.找到选择的行数据
                  if (val == option[v1][v2]) {
                    // 返显
                    label += option[frontEndConfig.label] + '、';
                    rows.push(option);
                  }
                });
              }
            });
          } else {
            value.map(val => {
              if (Array.isArray(this.options[valueOption || name])) {
                this.options[valueOption || name].map(option => {
                  // 1.找到选择的行数据
                  if (val == option[v]) {
                    // 返显
                    label += option[frontEndConfig.label] + '、';
                    rows.push(option);
                  }
                });
              }
            });
          }
          // 业务版下拉需要冗余存储字段让小程序反显
          this.$set(
            preset ? this.formData : this.formData.exts,
            name + 'Label',
            String(label).endsWith('、') ? label.substring(0, label.length - 1) : label
          );
          this.$set(
            this.formData.exts,
            name + 'Label',
            String(label).endsWith('、') ? label.substring(0, label.length - 1) : label
          );
          // 赋值
          if (frontEndConfig && frontEndConfig.setValue) {
            let setValue = frontEndConfig.setValue;
            for (let i = 0; i < rows.length; i++) {
              let row = rows[i];
              for (let key in setValue) {
                let value = setValue[key];
                if (key.startsWith('$')) {
                  key = key.substring('1');
                  if (key.indexOf('.') != -1) {
                    let key1 = key.split('.')[0];
                    let key2 = key.split('.')[1];
                    window.$this[key1] = window.$this[key1] || {};
                    if (i == 0) {
                      this.$set(window.$this[key1], key2, []);
                    } else {
                      if (!window.$this[key1][key2]) {
                        this.$set(window.$this[key1], key2, []);
                      }
                    }
                    if (String(value).startsWith('$')) {
                      value = value.substring(1);
                      if (value == 'row') {
                        window.$this[key1][key2].push(row);
                        this.$set(window.$this[key1], key2, window.$this[key1][key2]);
                      } else if (value.indexOf('.') != -1) {
                        let value1 = value.split('.')[0];
                        let value2 = value.split('.')[1];
                        row[value1] = row[value1] || {};
                        window.$this[key1][key2].push(row[value1][value2]);
                      } else {
                        window.$this[key1][key2].push(row[value]);
                      }
                    } else {
                      window.$this[key1][key2].push(value);
                    }
                  } else {
                    if (i == 0) {
                      this.$set(window.$this, key, []);
                    } else {
                      if (!window.$this[key]) {
                        this.$set(window.$this, key, []);
                      }
                    }
                    if (String(value).startsWith('$')) {
                      value = value.substring(1);
                      if (value == 'row') {
                        window.$this[key].push(row);
                        this.$set(window.$this, key, window.$this[key]);
                      } else if (value.indexOf('.') != -1) {
                        let value1 = value.split('.')[0];
                        let value2 = value.split('.')[1];
                        row[value1] = row[value1] || {};
                        window.$this[key].push(row[value1][value2]);
                      } else {
                        window.$this[key].push(row[value]);
                      }
                    } else {
                      window.$this[key].push(value);
                    }
                  }
                } else if (key.indexOf('.') != -1) {
                  let key1 = key.split('.')[0];
                  let key2 = key.split('.')[1];
                  this.formData[key1] = this.formData[key1] || {};
                  if (i == 0) {
                    this.$set(this.formData[key1], key2, this.formData[key1][key2] || []);
                  } else {
                    this.formData[key1][key2] = this.formData[key1][key2] || [];
                  }
                  if (String(value).startsWith('$')) {
                    value = value.substring(1);
                    if (value.indexOf('.') != -1) {
                      let value1 = value.split('.')[0];
                      let value2 = value.split('.')[1];
                      row[value1] = row[value1] || {};
                      this.formData[key1][key2].push(row[value1][value2]);
                    } else {
                      this.formData[key1][key2].push(row[value]);
                    }
                  } else {
                    this.formData[key1][key2].push(value);
                  }
                } else {
                  if (i == 0) {
                    this.$set(this.formData, key, []);
                  } else {
                    this.formData[key] = this.formData[key] || [];
                  }
                  if (String(value).startsWith('$')) {
                    value = value.substring(1);
                    if (value.indexOf('.') != -1) {
                      let value1 = value.split('.')[0];
                      let value2 = value.split('.')[1];
                      row[value1] = row[value1] || {};
                      this.formData[key].push(row[value1][value2]);
                    } else {
                      this.formData[key].push(row[value]);
                    }
                  } else {
                    this.formData[key].push(value);
                  }
                }
              }
            }
          }
        } else {
          // 返显
          this.$set(preset ? this.formData : this.formData.exts, name + 'Label', '');
          this.$set(this.formData.exts, name + 'Label', '');
          // 赋值为空数组
          if (frontEndConfig && frontEndConfig.setValue) {
            let setValue = frontEndConfig.setValue;
            for (let key in setValue) {
              if (key.startsWith('$')) {
                key = key.substring('1');
                if (key.indexOf('.') != -1) {
                  let key1 = key.split('.')[0];
                  let key2 = key.split('.')[1];
                  window.$this[key1] = window.$this[key1] || {};
                  this.$set(window.$this[key1], key2, []);
                } else {
                  this.$set(window.$this, key, []);
                }
              } else if (key.indexOf('.') != -1) {
                let key1 = key.split('.')[0];
                let key2 = key.split('.')[1];
                this.formData[key1] = this.formData[key1] || {};
                this.$set(this.formData[key1], key2, []);
              } else {
                this.$set(this.formData, key, []);
              }
            }
          }

          this.bizSelectRemote(null, f);
          return;
        }
      } else {
        // 关联业务档案-单选
        if (!value && value != '0') {
          this.bizSelectRemote(null, f);
          // 清空赋值
          if (frontEndConfig && frontEndConfig.setValue) {
            let setValue = frontEndConfig.setValue;
            for (let key in setValue) {
              if (key.indexOf('.') != -1) {
                this.$set(this.formData[key.split('.')[0]], key.split('.')[1], '');
              } else {
                this.$set(this.formData, key, '');
              }
            }
          }
          // 删除exts中冗余存储的Label字段
          delete this.formData[name + 'Label'];
          delete this.formData.exts[name + 'Label'];
          return;
        }
        // 找到选择业务对象的索引
        let labelIndex;
        if (this.options[valueOption || name]) {
          labelIndex = this.options[valueOption || name].findIndex(item =>
            frontEndConfig.value && frontEndConfig.value.indexOf('.') != -1
              ? item[frontEndConfig.value.split('.')[0]][frontEndConfig.value.split('.')[1]] ==
                (preset ? this.formData[name] : this.formData.exts[name])
              : item[frontEndConfig.value || '_id'] ==
                (preset ? this.formData[name] : this.formData.exts[name])
          );

          // 业务版下拉需要冗余存储字段让小程序反显
          if (this.options[valueOption || name][labelIndex]) {
            this.$set(
              preset ? this.formData : this.formData.exts,
              name + 'Label',
              this.options[valueOption || name][labelIndex].label
            );
            this.$set(
              this.formData.exts,
              name + 'Label',
              this.options[valueOption || name][labelIndex].label
            );
          }
        }
        let row = this.options[valueOption || name][labelIndex];
        // 支持为其他字段赋值
        if (frontEndConfig && frontEndConfig.setValue && labelIndex >= 0) {
          var setValue = frontEndConfig.setValue;
          for (let key in setValue) {
            let val = setValue[key];
            if (!val && val != 0) continue;
            if (key.indexOf('.') != -1) {
              if (key.startsWith('$')) {
                key = key.substring(1);
                let key0 = key.split('.')[0];
                let key1 = key.split('.')[1];
                window.$this[key0] = window.$this[key0] || {};
                window.$this[key0][key1] = window.$this[key0][key1] || [];
                if (String(val).startsWith('$')) {
                  val = val.substring(1);
                  if (val == 'row') {
                    window.$this[key0][key1].push(row);
                    this.$set(window.$this[key0], key1, window.$this[key0][key1]);
                  } else if (val.indexOf('.') != -1) {
                    let val0 = val.split('.')[0];
                    let val1 = val.split('.')[1];
                    row[val0] = row[val0] || {};
                    window.$this.$set(window.$this[key0], key1, row[val0][val1]);
                  } else {
                    window.$this.$set(window.$this[key0], key1, row[val]);
                  }
                } else {
                  window.$this.$set(window.$this[key0], key1, val);
                }
              } else {
                let key0 = key.split('.')[0];
                let key1 = key.split('.')[1];
                this.formData[key0] = this.formData[key0] || {};
                this.formData[key0][key1] = this.formData[key0][key1] || [];
                if (String(val).startsWith('$')) {
                  val = val.substring(1);
                  if (val == 'row') {
                    this.formData[key0][key1].push(row);
                    this.$set(this.formData[key0], key1, this.formData[key0][key1]);
                  } else if (val.indexOf('.') != -1) {
                    let val0 = val.split('.')[0];
                    let val1 = val.split('.')[1];
                    row[val0] = row[val0] || {};
                    window.$this.$set(this.formData[key0], key1, row[val0][val1]);
                  } else {
                    window.$this.$set(this.formData[key0], key1, row[val]);
                  }
                } else {
                  window.$this.$set(this.formData[key0], key1, val);
                }
              }
            } else {
              if (String(val).startsWith('$')) {
                val = val.substring(1);
                if (val == 'row') {
                  this.formData[key].push(row);
                  this.$set(this.formData, key, this.formData[key]);
                } else if (val.indexOf('.') != -1) {
                  let val0 = val.split('.')[0];
                  let val1 = val.split('.')[1];
                  row[val0] = row[val0] || {};
                  window.$this.$set(this.formData, key, row[val0][val1]);
                } else {
                  window.$this.$set(this.formData, key, row[val]);
                }
              } else {
                window.$this.$set(this.formData, key, val);
              }
            }
          }
          this.$forceUpdate();
        } else if (
          frontEndConfig &&
          frontEndConfig.setValue &&
          frontEndConfig.allowCreate &&
          labelIndex == -1
        ) {
          let setValue = frontEndConfig.setValue;
          for (let key in setValue) this.$set(this.formData, key, '');
        }
        this.$emit('changeForm', this.formData);
        // 计算
        this.scriptToCalculate(f, this.formData, null, row);
      }
    },
    // 关联业务档案字段 支持搜索
    bizSelectRemote(query, item) {
      if (!item.frontEndConfig.url) return;
      // 处理请求参数
      let params = item.frontEndConfig.params;
      let obj = {};
      let formData = this.formData || { exts: {} };
      for (let key in params) {
        let val = params[key];
        if (!val) continue;
        if (String(val).startsWith('$')) {
          // 使用formData的字段值
          val = val.substring(1);
          if (val.indexOf('.') != -1) {
            let val0 = val.split('.')[0];
            let val1 = val.split('.')[1];
            formData[val0] = formData[val0] || {};
            obj[key] = Array.isArray(formData[val0][val1])
              ? formData[val0][val1].join()
              : formData[val0][val1];
          } else {
            obj[key] = Array.isArray(formData[val]) ? formData[val].join() : formData[val];
          }
        } else if (String(val).startsWith('#')) {
          // 使用输入的值
          val = val.substring(1);
          if (val == 'query') {
            obj[key] = query;
          }
        }
      }
      this.osg.ajax(
        item.frontEndConfig.url,
        Object.assign({}, params, obj),
        res => {
          res.data.map(obj => {
            obj.label = obj[item.frontEndConfig.label] || obj.name;
            if (item.frontEndConfig.value && item.frontEndConfig.value.indexOf('.') != -1) {
              let val0 = item.frontEndConfig.value.split('.')[0];
              let val1 = item.frontEndConfig.value.split('.')[1];
              obj[val0] = obj[val0] || {};
              obj.value = obj[val0][val1];
            } else {
              obj.value = obj[item.frontEndConfig.value] || obj._id;
            }
          });
          this.options[item.valueOption] = res.data;
          this.$forceUpdate();
          this.$emit('changeForm', this.formData);
        },
        item.frontEndConfig.options || {}
      );
    },
    uploadSuccess() {
      return this.osg.uploadSuccess(...arguments, this);
    },
    beforeRemove() {
      return this.osg.beforeRemove(...arguments, () => {}, this);
    },
    beforeRemoveCon() {
      let res = true;
      res = this.$confirm('是否确认全部删除？');
      return res;
    },
    pageSizeChange(pageSize) {
      if (this.product.open) {
        this.product.fpi.rows = pageSize;
        this.getProduct();
      } else if (this.action.show) {
        this.action.fpi.rows = pageSize;
        this.actionClick();
      }
    },
    pageChange(currentPage) {
      if (this.product.open) {
        this.product.fpi.page = currentPage;
        this.getProduct();
      } else if (this.action.show) {
        this.action.fpi.page = currentPage;
        this.actionClick();
      }
    },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    formatProductType(row, column, cellValue) {
      return this.osg.codelabel('productType', cellValue);
    },
    getProduct(f) {
      if (f) {
        this.product.f = f;
      } else {
        f = this.product.f || {};
      }
      let selectIds = [];
      this.formData[f.name] = this.formData[f.name] || [];
      for (let item of this.formData[f.name]) {
        selectIds.push(item._id);
      }

      let params = {
        page: this.product.fpi.page,
        rows: this.product.fpi.rows,
        'regex:name|string#or': this.product.searchValue,
        'regex:code|string#or': this.product.searchValue,
        'nin:_id|string#and': selectIds,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // 字段配置的params覆盖
      let obj = f.frontEndConfig.params;
      for (let key in obj) {
        params[key] = obj[key];
      }

      this.osg.ajax(
        f.frontEndConfig.url || 'basic/product/query.do',
        params,
        res => {
          this.product.fpi = res;
          this.product.open = true;
        },
        { noload: true }
      );
    },
    productSelect(val) {
      this.product.selectRows = val;
    },
    saveSelectProduct() {
      let f = this.product.f;
      let that = this;
      that.product.selectRows.map(item => {
        item.number = 0;
      });
      this.formData[f.name] = this.formData[f.name] || [];
      this.formData[f.name] = this.formData[f.name].concat(
        that.$util.deepCopy(that.product.selectRows)
      );
      this.product.open = false;
      this.calculate();
    },
    cancelSelectProduct() {
      this.product.selectRows = [];
      this.product.open = false;
    },
    removeProduct(f, index) {
      this.product.f = f;
      this.formData[f.name].splice(index, 1);
      this.calculate();
    },
    numChange(f) {
      this.product.f = f;
      this.calculate();
    },
    calculate() {
      let f = this.product.f;
      let list = this.formData[f.name] || [];
      let totalField = f.frontEndConfig.total;
      let costField = f.frontEndConfig.cost;
      if (totalField) {
        let total = 0;
        for (let item of list) {
          total += Number(item.price) * Number(item.number);
        }
        this.formData[totalField] = parseFloat(total.toFixed(2));
        this.$forceUpdate();
      }
      if (costField) {
        let cost = 0;
        for (let item of list) {
          cost += Number(item.cost) * Number(item.number);
        }
        this.formData[costField] = parseFloat(cost.toFixed(2));
        this.$forceUpdate();
      }
    },
    /**
     * 参照
     */
    requestClick(f) {
      if (f) {
        this.request.f = f;
      } else {
        f = this.request.f || {};
      }
      this.request.fieldName = f.name;
      this.request.valueOption = f.valueOption;
      let selectIds = [];
      this.formData[f.name] = this.formData[f.name] || [];
      for (let item of this.formData[f.name]) {
        selectIds.push(item._id);
      }

      let params = f.frontEndConfig.params;
      let formData = this.formData || { exts: {} };
      let obj = {};
      for (let key in params) {
        let val = params[key];
        if (!val && val != 0) continue;
        if (String(val).startsWith('$')) {
          obj[key] = formData[val.substring(1)];
        } else if (String(val).startsWith('#')) {
          obj[key] = null;
        }
      }

      params = Object.assign(params, obj);

      this.osg.ajax(
        f.frontEndConfig.url,
        params,
        res => {
          res.data.map(obj => {
            obj.label = obj[f.frontEndConfig.label] || obj.name;
            obj.value = obj[f.frontEndConfig.value] || obj._id;
          });
          this.request.open = true;
          this.$nextTick(() => {
            this.requestOptions[f.valueOption || f.name] = res.data;
            this.request.fpi = res;
            this.$nextTick(() => {
              this.$refs.request.doLayout();
            });
          });
        },
        { noload: true }
      );
    },
    requestSelect(val) {
      this.request.selectRows = val;
    },
    saveSelectRequest() {
      let f = this.request.f;
      let that = this;
      that.request.selectRows.map(item => {
        item.number = 0;
      });
      if (f.preset) {
        this.formData[f.name] = this.formData[f.name] || [];
        this.formData[f.name] = this.formData[f.name].concat(
          that.$util.deepCopy(that.request.selectRows)
        );
      } else {
        this.formData.exts = this.formData.exts || {};
        this.formData.exts[f.name] = this.formData.exts[f.name] || [];
        this.formData.exts[f.name] = this.formData.exts[f.name].concat(
          that.$util.deepCopy(that.request.selectRows)
        );
      }
      this.request.open = false;
    },
    cancelSelectRequest() {
      this.request.selectRows = [];
      this.request.open = false;
    },
    requestTableSelect(val) {
      this.requestTable.selectRows = val;
    },
    actionClick(action, field) {
      action = action || this.action.def || {};
      field = field || this.action.field || {};

      action = this.$util.deepCopy(action);
      this.action.def = action;
      this.action.field = field;

      // 删除
      if (action.type == 'delete') {
        if (this.requestTable.selectRows.length == 0) {
          this.osg.toast('请至少勾选1条数据！');
        } else {
          this.osg.confirm(
            `是否确认删除勾选的${this.requestTable.selectRows.length}条数据？`,
            () => {
              let newData = [];
              let data = field.preset
                ? this.formData[field.name] || []
                : this.formData.exts[field.name] || [];
              for (let item of data) {
                let has = false;
                for (let i = 0; i < this.requestTable.selectRows.length; i++) {
                  let row = this.requestTable.selectRows[i];
                  if (item == row) {
                    has = true;
                  }
                }
                if (!has) newData.push(item);
              }
              field.preset
                ? this.$set(this.formData, field.name, newData)
                : this.$set(this.formData.exts, field.name, newData);
              this.$emit('changeForm', this.formData);
              if (action.scriptId)
                this.getScriptToCalculate(action.scriptId, this.formData, action.scriptParams);
              this.osg.toast('删除成功');
            }
          );
        }
        return;
      }

      // 如果是批量更新子表中已有数据字段值，至少勾选1条数据
      if (action.confirmType == 'update' && this.requestTable.selectRows.length == 0) {
        this.osg.toast('请至少勾选1条数据！', 'warning');
        return;
      }
      if (action.type == 'request') {
        // 请求类型
        // 1.请求弹出表格的字段
        if (!action.colName) return;
        this.osg.ajax(
          'biz/extField/query.do',
          {
            _all: '1',
            'is:state|integer#and': 1,
            sortField: 'order',
            sortOrder: 'asc',
            colName: action.colName
          },
          async res => {
            res.data.map(item => {
              if (this.$util.isJson(item.frontEndConfig)) {
                item.frontEndConfig = JSON.parse(item.frontEndConfig);
              } else {
                item.frontEndConfig = {};
              }
            });
            this.action.fields = res.data;

            // 2.请求字段关联字典表
            // 2.1整理需要请求的字典
            let options = {};
            let cfgArr = [];
            let cascadeTypes = [];
            for (let field of res.data) {
              if (field.valueOption && field.type != 'bizSelect' && field.type != 'request') {
                if (field.type == 'cascade') {
                  cascadeTypes.push(field.valueOption);
                } else {
                  cfgArr.push({
                    codeId: field.valueOption,
                    eleid: field.valueOption
                  });
                }
              }
              // 列不固定时删除fixed字段，解决el-table-column组件fixed为空字符串依然固定在左侧的问题
              if (!field.fixed) {
                delete field.fixed;
              }
            }
            // 2.2请求字典表
            if (cfgArr.length > 0) {
              await new Promise(resolve => {
                this.osg.ajax(
                  'i/code/selectCode.do',
                  {
                    jsonPara: JSON.stringify(cfgArr)
                  },
                  res => {
                    if (res) {
                      res = JSON.parse(res);
                      for (var i = 0; i < res.length; i++) {
                        var opts = res[i],
                          os = opts.options;
                        var osArr = [];
                        for (let opt in os) {
                          osArr.push({
                            label: os[opt],
                            value: opt
                          });
                        }
                        options[opts.eleid] = osArr;
                      }
                      resolve();
                    }
                  },
                  {
                    noload: false
                  }
                );
              });
            }
            // 2.2查询级联代码表数据
            if (cascadeTypes.length > 0) {
              await new Promise(resolve => {
                this.osg.ajax(
                  'i/code/selectMultistageCode.do',
                  {
                    types: cascadeTypes.join()
                  },
                  res => {
                    if (res.constructor == Array) {
                      res.map(item => {
                        options[item.type] = this.osg.removeEmpty(item.children, 'children');
                      });
                    }
                    resolve();
                  },
                  {
                    noload: true
                  }
                );
              });
            }
            this.$set(this.action, 'options', options);
            // 返显
            window.$this.requestOptions = Object.assign(window.$this.requestOptions, options);

            // 3.请求弹出表格数据
            if (!action.url) return;
            let params = action.params || {};

            let formData = this.formData || { exts: {} };
            let obj = {};
            for (let key in params) {
              let val = params[key];
              if (!val && val != 0) continue;
              if (String(val).startsWith('$form.')) {
                val = val.substring(6);
                if (val.indexOf('.') != -1) {
                  let val1 = val.split('.')[0];
                  let val2 = val.split('.')[1];
                  formData[val1] = formData[val1] || {};
                  obj[key] = Array.isArray(formData[val1][val2])
                    ? formData[val1][val2].join()
                    : formData[val1][val2];
                } else {
                  obj[key] = Array.isArray(formData[val]) ? formData[val].join() : formData[val];
                }
              } else if (String(val).startsWith('$')) {
                val = val.substring(1);
                if (val.indexOf('.') != -1) {
                  let val1 = val.split('.')[0];
                  let val2 = val.split('.')[1];
                  if (val1.toLowerCase() == 'json') {
                    obj[key] = JSON.stringify(formData[val2]);
                  } else {
                    formData[val1] = formData[val1] || {};
                    obj[key] = Array.isArray(formData[val1][val2])
                      ? formData[val1][val2].join()
                      : formData[val1][val2];
                  }
                } else {
                  obj[key] = Array.isArray(formData[val]) ? formData[val].join() : formData[val];
                }
              } else if (String(val).startsWith('#')) {
                obj[key] = null;
              }
            }
            // 处理过滤条件
            if (action.filterDef) {
              let filterDef = action.filterDef;
              for (let key in filterDef) {
                let val = filterDef[key];
                if (!val && val != 0) continue;
                if (String(val).startsWith('$')) {
                  val = val.substring(1);
                  obj[key] = Array.isArray(this.action.filter[val])
                    ? this.action.filter[val].join()
                    : this.action.filter[val];
                }
              }
            }

            // 切换分页
            if (this.action.fpi.page) obj.page = this.action.fpi.page;
            if (this.action.fpi.rows) obj.rows = this.action.fpi.rows;

            this.osg.ajax(
              action.url,
              Object.assign(params, obj),
              res => {
                res.data.map(obj => {
                  obj.label = action.label ? obj[action.label] : obj.name;
                  obj.value = action.value ? obj[action.value] : obj._id;
                });
                // 返回结果处理
                if (action.setResData) {
                  res.data.map(obj => {
                    for (let key in action.setResData) {
                      let val = action.setResData[key];
                      if (val.startsWith('$')) {
                        val = val.substring(1);
                        if (key.indexOf('.') != -1) {
                          let key0 = key.split('.')[0];
                          let key1 = key.split('.')[1];
                          obj[key0] = obj[key0] || {};
                          if (val.indexOf('.') != -1) {
                            let val0 = val.split('.')[0];
                            let val1 = val.split('.')[1];
                            obj[val0] = obj[val0] || {};
                            obj[key0][key1] = obj[val0][val1];
                          } else {
                            obj[key0][key1] = obj[val];
                          }
                        } else {
                          if (val.indexOf('.') != -1) {
                            let val0 = val.split('.')[0];
                            let val1 = val.split('.')[1];
                            obj[val0] = obj[val0] || {};
                            obj[key] = obj[val0][val1];
                          } else {
                            obj[key] = obj[val];
                          }
                        }
                      } else {
                        if (key.indexOf('.') != -1) {
                          let key0 = key.split('.')[0];
                          let key1 = key.split('.')[1];
                          obj[key0] = obj[key0] || {};
                          obj[key0][key1] = val;
                        } else {
                          obj[key] = val;
                        }
                      }
                    }
                  });
                }

                this.action.show = true;
                this.$nextTick(() => {
                  this.action.fpi = res;
                  this.$nextTick(() => {
                    this.$refs.actionTable.doLayout();
                  });
                });
              },
              { noload: true }
            );
          },
          {
            noload: true
          }
        );
      } else if (action.type == 'hideRequest') {
        // 3.请求弹出表格数据
        if (!action.url) return;
        let params = action.params || {};
        let formData = this.formData || { exts: {} };
        let obj = {};
        for (let key in params) {
          let val = params[key];
          if (!val && val != 0) continue;
          if (String(val).startsWith('$')) {
            val = val.substring(1);
            if (val.indexOf('.') != -1) {
              let val1 = val.split('.')[0];
              let val2 = val.split('.')[1];
              if (val1.toLowerCase() == 'json') {
                obj[key] = JSON.stringify(formData[val2]);
              } else if (val1.toLowerCase() == 'assign') {
                if (key == 'obj') {
                  obj = Object.assign(obj, formData[val2]);
                } else {
                  obj[key] = Object.assign(obj[key], formData[val2]);
                }
              } else {
                formData[val1] = formData[val1] || {};
                obj[key] = Array.isArray(formData[val1][val2])
                  ? formData[val2].join()
                  : formData[val2];
              }
            } else {
              obj[key] =
                Array.isArray(formData[val]) && !action.paramsToJson
                  ? formData[val].join()
                  : formData[val];
            }
          } else if (String(val).startsWith('#')) {
            obj[key] = null;
          }
        }
        // 请求参数整体转json
        if (action.paramsToJson) {
          obj = {
            [action.paramsToJson]: JSON.stringify(Object.assign(params, obj))
          };
          params = {};
        }

        // 处理过滤条件
        if (action.filterDef) {
          let filterDef = action.filterDef;
          for (let key in filterDef) {
            let val = filterDef[key];
            if (!val && val != 0) continue;
            if (String(val).startsWith('$')) {
              val = val.substring(1);
              obj[key] = Array.isArray(this.action.filter[val])
                ? this.action.filter[val].join()
                : this.action.filter[val];
            }
          }
        }

        // 切换分页
        if (this.action.fpi.page) obj.page = this.action.fpi.page;
        if (this.action.fpi.rows) obj.rows = this.action.fpi.rows;

        this.osg.ajax(
          action.url,
          Object.assign(params, obj),
          res => {
            res.data.map(obj => {
              obj.label = action.label ? obj[action.label] : obj.name;
              obj.value = action.value ? obj[action.value] : obj._id;
            });
            this.action.fpi = res;
            // 自动确认
            this.actionConfirm();
          },
          { noload: true }
        );
      }
    },
    actionSelect(val) {
      this.action.selectRows = val;
    },
    actionConfirm() {
      let action = this.action.def;
      let selectRows = this.action.selectRows;
      let field = this.action.field;
      let confirmType = action.confirmType;
      let setValue = action.setValue;

      if (confirmType == 'new') {
        // confirmType:new 新建对象 赋值后 插入主表数组中
        if (setValue.url) {
          if (this.action.selectRows.length > 0) {
            // 根据选中数据的指定字段，发送二次请求
            let formData = this.formData || { exts: {} };
            let obj = {};
            let params = setValue.params;
            if (params) {
              for (let key in params) {
                let val = params[key];
                if (!val && val != 0) continue;
                if (String(val).startsWith('$rows.')) {
                  if (String(val).indexOf(',') != -1) {
                    // 例如："$row._id,$row.id"
                    let rowKey1 = String(val)
                      .split(',')[0]
                      .split('.')[1];
                    let rowKey2 = String(val)
                      .split(',')[1]
                      .split('.')[1];
                    let rowValues = [];
                    this.action.selectRows.map(row => {
                      if (row[rowKey1] || row[rowKey1] == 0) rowValues.push(row[rowKey1]);
                      if (row[rowKey2] || row[rowKey2] == 0) rowValues.push(row[rowKey2]);
                    });
                    obj[key] = rowValues.join();
                  } else {
                    // 例如取所有选中行的_id，作为新的查询条件
                    let rowKey = String(val).split('.')[1];
                    let rowValues = [];
                    this.action.selectRows.map(row => {
                      if (row[rowKey] || row[rowKey] == 0) rowValues.push(row[rowKey]);
                    });
                    obj[key] = rowValues.join();
                  }
                } else if (String(val).startsWith('$')) {
                  obj[key] = formData[val.substring(1)];
                } else if (String(val).startsWith('#')) {
                  obj[key] = null;
                }
              }
            }

            this.osg.ajax(
              setValue.url,
              Object.assign(params, obj),
              res => {
                res.data.map(obj => {
                  obj.label = setValue.label ? obj[setValue.label] : obj.name;
                  obj.value = setValue.value ? obj[setValue.value] : obj._id;
                });
                // TODO: 解决了问题:新添加的关联业务档案类型的数据，非前20条会显示id
                if (setValue.setOptions) {
                  for (let key in setValue.setOptions) {
                    key = key.substring(1);
                    if (key.indexOf('.') != -1) {
                      let key0 = key.split('.')[0];
                      let key1 = key.split('.')[1];

                      this[key0] = this[key0] || {};
                      this[key0][key1] = this[key0][key1] || [];

                      let optionValues = this[key0][key1].map(item => item.value);
                      let newOptions = this.action.selectRows.filter(
                        item =>
                          optionValues.indexOf(item._id) == -1 &&
                          optionValues.indexOf(item.value) == -1
                      );
                      this.$set(this[key0], key1, this[key0][key1].concat(newOptions));
                    }
                  }
                }
                if (setValue.inheritParentKey && setValue.inheritSubKey && setValue.inheritValue) {
                  let inheritValue = setValue.inheritValue;
                  res.data.map(obj => {
                    for (let key in inheritValue) {
                      let val = inheritValue[key];
                      if (val.startsWith('$row.')) val = val.split('.')[1];
                      for (let i = 0; i < this.action.selectRows.length; i++) {
                        let selectRow = this.action.selectRows[i];
                        if (Array.isArray(setValue.inheritParentKey)) {
                          let inherit = false;
                          for (let j = 0; j < setValue.inheritParentKey.length; j++) {
                            let k = setValue.inheritParentKey[j];
                            if (selectRow[k] == obj[setValue.inheritSubKey]) {
                              obj[key] = selectRow[val];
                              inherit = true;
                              break;
                            }
                          }
                          // 完成继承赋值
                          if (inherit) break;
                        } else {
                          if (selectRow[setValue.inheritParentKey] == obj[setValue.inheritSubKey]) {
                            obj[key] = selectRow[val];
                            break;
                          }
                        }
                      }
                    }
                  });
                }
                // 将二次请求返回的数据部分值插入到主表数据中
                if (setValue.setValue) {
                  //  选择字段来赋值
                  let data = [];
                  for (let row of res.data) {
                    let obj = { exts: {} };
                    for (let key in setValue.setValue) {
                      let val = setValue.setValue[key];
                      if (key.indexOf('.') == -1) {
                        if (!val && val != 0) continue;
                        if (String(val).startsWith('$form.')) {
                          val = val.substring(6);
                          if (val.indexOf('.') != -1) {
                            let val1 = val.split('.')[0];
                            let val2 = val.split('.')[1];
                            obj[key] = this.formData[val1] && this.formData[val1][val2];
                          } else {
                            obj[key] = this.formData[val];
                          }
                        } else if (String(val).startsWith('$')) {
                          val = val.substring(1);
                          if (val.indexOf('.') != -1) {
                            let val1 = val.split('.')[0];
                            let val2 = val.split('.')[1];
                            obj[key] = (row[val1] && row[val1][val2]) || '';
                          } else {
                            obj[key] = row[val];
                          }
                        } else if (String(val).startsWith('#')) {
                          obj[key] = null;
                        } else {
                          obj[key] = val;
                        }
                      } else {
                        let key1 = key.split('.')[0];
                        let key2 = key.split('.')[1];
                        obj[key1] = obj[key1] || {};
                        if (!val && val != 0) continue;
                        if (String(val).startsWith('$form.')) {
                          val = val.substring(6);
                          if (val.indexOf('.') != -1) {
                            let val1 = val.split('.')[0];
                            let val2 = val.split('.')[1];
                            obj[key1][key2] = this.formData[val1] && this.formData[val1][val2];
                          } else {
                            obj[key1][key2] = this.formData[val];
                          }
                        } else if (String(val).startsWith('$')) {
                          val = val.substring(1);
                          if (val.indexOf('.') != -1) {
                            let val1 = val.split('.')[0];
                            let val2 = val.split('.')[1];
                            obj[key1][key2] = (row[val1] && row[val1][val2]) || '';
                          } else {
                            obj[key1][key2] = row[val];
                          }
                        } else if (String(val).startsWith('#')) {
                          obj[key1][key2] = null;
                        } else {
                          obj[key1][key2] = val;
                        }
                      }
                    }
                    data.push(obj);
                  }
                  if (field.preset) {
                    this.formData[field.name] = this.formData[field.name] || [];
                    this.formData[field.name] = this.formData[field.name].concat(data);
                  } else {
                    this.formData.exts = this.formData.exts || {};
                    this.formData.exts[field.name] = this.formData.exts[field.name] || [];
                    this.formData.exts[field.name] = this.formData.exts[field.name].concat(data);
                  }
                } else {
                  // 将二次返回的数据全部插入到主表数据中
                  let that = this;
                  if (field.preset) {
                    this.formData[field.name] = this.formData[field.name] || [];
                    this.formData[field.name] = this.formData[field.name].concat(
                      that.$util.deepCopy(res.data)
                    );
                  } else {
                    this.formData.exts = this.formData.exts || {};
                    this.formData.exts[field.name] = this.formData.exts[field.name] || [];
                    this.formData.exts[field.name] = this.formData.exts[field.name].concat(
                      that.$util.deepCopy(res.data)
                    );
                  }
                }
                // 触发脚本计算
                if (setValue.scriptId)
                  this.getScriptToCalculate(
                    setValue.scriptId,
                    this.formData,
                    setValue.scriptParams
                  );
              },
              { noload: true }
            );
          }
        } else {
          // 将选中数据的指定字段插入主表数组中
          let data = [];
          for (let row of selectRows) {
            let obj = { exts: {} };
            for (let key in setValue) {
              let val = setValue[key];
              if (key.indexOf('.') == -1) {
                if (!val && val != 0) continue;
                if (String(val).startsWith('$form.')) {
                  val = val.substring(6);

                  if (val.indexOf('.') != -1) {
                    let val1 = val.split('.')[0];
                    let val2 = val.split('.')[1];
                    this.formData[val1] = this.formData[val1] || {};
                    obj[key] = Array.isArray(this.formData[val1][val2])
                      ? this.formData[val1][val2].join()
                      : this.formData[val1][val2];
                  } else {
                    obj[key] = Array.isArray(this.formData[val])
                      ? this.formData[val].join()
                      : this.formData[val];
                  }
                } else if (String(val).startsWith('$')) {
                  val = val.substring(1);
                  if (val.indexOf('.') != -1) {
                    let val1 = val.split('.')[0];
                    let val2 = val.split('.')[1];
                    obj[key] = (row[val1] && row[val1][val2]) || '';
                  } else {
                    obj[key] = row[val];
                  }
                } else if (String(val).startsWith('#')) {
                  obj[key] = null;
                } else {
                  obj[key] = val;
                }
              } else {
                let key1 = key.split('.')[0];
                let key2 = key.split('.')[1];
                obj[key1] = obj[key1] || {};
                if (!val && val != 0) continue;
                if (String(val).startsWith('$')) {
                  val = val.substring(1);
                  if (val.indexOf('.') != -1) {
                    let val1 = val.split('.')[0];
                    let val2 = val.split('.')[1];
                    obj[key1][key2] = (row[val1] && row[val1][val2]) || '';
                  } else {
                    obj[key1][key2] = row[val];
                  }
                } else if (String(val).startsWith('#')) {
                  obj[key1][key2] = null;
                } else {
                  obj[key1][key2] = val;
                }
              }
            }
            data.push(obj);
          }
          if (field.preset) {
            this.formData[field.name] = this.formData[field.name] || [];
            this.formData[field.name] = this.formData[field.name].concat(data);
          } else {
            this.formData.exts = this.formData.exts || {};
            this.formData.exts[field.name] = this.formData.exts[field.name] || [];
            this.formData.exts[field.name] = this.formData.exts[field.name].concat(data);
          }

          if (setValue.scriptId)
            this.getScriptToCalculate(setValue.scriptId, this.formData, setValue.scriptParams);
        }
      } else if (confirmType == 'add') {
        let that = this;
        if (setValue) {
          that.action.selectRows.map(row => {
            for (let key in setValue) {
              let value = setValue[key];
              if (key.indexOf('.') != -1) {
                let key1 = key.split('.')[0];
                let key2 = key.split('.')[1];
                row[key1] = row[key1] || {};
                row[key1][key2] = value;
              } else {
                row[key] = value;
              }
            }
          });
        }
        // confirmType:add 将选中的原对象 全部字段插入主表数组中
        if (field.preset) {
          this.formData[field.name] = this.formData[field.name] || [];
          this.formData[field.name] = this.formData[field.name].concat(
            that.$util.deepCopy(that.action.selectRows)
          );
        } else {
          this.formData.exts = this.formData.exts || {};
          this.formData.exts[field.name] = this.formData.exts[field.name] || [];
          this.formData.exts[field.name] = this.formData.exts[field.name].concat(
            that.$util.deepCopy(that.action.selectRows)
          );
        }
      } else if (confirmType == 'update') {
        // confirmType:update 更新已选中数据
        if (selectRows.length != 1) {
          this.osg.toast('请勾选1条数据！', 'warning');
          return;
        }

        let row = selectRows[0];
        this.requestTable.selectRows.map(obj => {
          for (let key in setValue) {
            let val = setValue[key];
            if (key.indexOf('.') == -1) {
              if (!val && val != 0) continue;
              if (String(val).startsWith('$')) {
                val = val.substring(1);
                if (val.indexOf('.') != -1) {
                  let val1 = val.split('.')[0];
                  let val2 = val.split('.')[1];
                  this.$set(obj, key, (row[val1] && row[val1][val2]) || '');
                } else {
                  this.$set(obj, key, row[val]);
                }
              } else if (String(val).startsWith('#')) {
                this.$set(obj, key, null);
              } else {
                this.$set(obj, key, val);
              }
            } else {
              let key1 = key.split('.')[0];
              let key2 = key.split('.')[1];
              obj[key1] = obj[key1] || {};
              if (!val && val != 0) continue;
              if (String(val).startsWith('$')) {
                val = val.substring(1);
                if (val.indexOf('.') != -1) {
                  let val1 = val.split('.')[0];
                  let val2 = val.split('.')[1];
                  this.$set(obj[key1], key2, (row[val1] && row[val1][val2]) || '');
                } else {
                  this.$set(obj[key1], key2, row[val]);
                }
              } else if (String(val).startsWith('#')) {
                this.$set(obj[key1], key2, null);
              } else {
                this.$set(obj[key1], key2, val);
              }
            }
          }
        });
      } else if (confirmType == 'replace') {
        // confirmType:replace 将返回数据全部替换原子表数据
        if (field.preset) {
          this.formData[field.name] = this.action.fpi.data;
        } else {
          this.formData.exts = this.formData.exts || {};
          this.formData.exts[field.name] = this.action.fpi.data;
        }
      }
      if (action.scriptId)
        this.getScriptToCalculate(action.scriptId, this.formData, action.scriptParams);
      this.action.show = false;
    },
    actionCancel() {
      // this.action.show = false;

      this.$set(this, 'action', {
        def: {},
        field: {}, //主表字段
        filter: {},
        show: false,
        fields: [],
        options: {},
        fpi: { data: [] },
        selectRows: []
      });
    },
    tableCellClassName({ row, column, rowIndex }) {
      row.rowIndex = rowIndex;
    },
    tableEditingChange(data, row) {
      if (!row.editing) {
        this.$set(row, 'editing', true);
        data.map(item => {
          if (item.rowIndex != row.rowIndex) this.$set(item, 'editing', false);
        });
      }
    },
    requestEdit(f, row) {
      this.requestForm.f = f;
      this.requestForm.fieldName = f.name;
      this.$util.renderExtField(this.options[(f.valueOption || f.name) + 'Fields'], row);
      this.requestForm.formData = row;
      this.requestForm.open = true;
    },
    requestSave() {
      this.requestForm.open = false;
    },
    requestCancel() {
      this.requestForm.open = false;
    },
    requestRemove(item, row, index) {
      this.osg.confirm(`是否确认删除${row.name ? row.name : '第' + (index + 1) + '行'}？`, () => {
        if (item.preset) {
          this.formData[item.name].splice(index, 1);
        } else {
          this.formData.exts[item.name].splice(index, 1);
        }
        this.osg.toast('删除成功');
      });
    },
    /**
     * 添加联系人
     */
    phoneAdd(f) {
      if (!this.formData.exts[f.name + 'List']) {
        this.$set(this.formData.exts, f.name + 'List', [
          {
            relation: '',
            name: '',
            phone: '',
            default: false
          }
        ]);
        this.$set(this.formData.exts, 'contactsPhone', []);
      } else {
        if (!this.formData.exts[f.name + 'List'])
          this.$set(this.formData.exts, 'contactsPhone', []);
        this.formData.exts[f.name + 'List'].push({
          relation: '',
          name: '',
          phone: '',
          default: false
        });
      }
      this.$forceUpdate();
    },
    phoneRemove(f, j) {
      this.osg.confirm('是否确认删除？', () => {
        this.formData.exts[f.name + 'List'].splice(j, 1);
        this.formData.exts.contactsPhone.splice(j, 1);
      });
    },
    phoneSetDefault(f, j) {
      for (let i = 0; i < this.formData.exts[f.name + 'List'].length; i++) {
        let phoneMap = this.formData.exts[f.name + 'List'][i];
        if (i == j) {
          phoneMap.default = true;
        } else {
          phoneMap.default = false;
        }
      }
    },
    phoneCancelDefault(f, j) {
      this.formData.exts[f.name + 'List'][j].default = false;
    },
    phoneBlur(value, j) {
      // 往contactsPhone字段放手机号，方便列表过滤
      this.formData.exts.contactsPhone = this.formData.exts.contactsPhone || [];
      this.formData.exts.contactsPhone[j] = value;
    },
    setOptions(valueOption, data) {
      this.options[valueOption] = data;
      this.requestOptions[valueOption] = data;
      this.$forceUpdate();
    },
    //自动获取匹配地址
    autoAddress(queryString, cb) {
      AMap.plugin('AMap.AutoComplete', function() {
        // 实例化Autocomplete
        var autoOptions = {
          city: '全国'
        };
        var autoComplete = new AMap.Autocomplete(autoOptions);
        autoComplete.search(queryString, function(status, result) {
          //搜索成功时，result即是对应的匹配数据
          if (Array.isArray(result.tips))
            result.tips = result.tips.filter(item => (item.value = item.name ? item.name : ''));
          cb(result.tips || []);
        });
      });
    },
    //选择关键词搜索详细地址 线索、客户详情也有此方法 如有改动请同步
    autoAddressSelect(item) {
      //根据中文和adcode返回省市区街道编码值
      this.osg.addressCodeSearch(item.name, item.adcode, resData => {
        //获取街道
        this.osg.getSubdistricts(resData.area, result => {
          this.options.subdistricts = result;
          this.$forceUpdate();
          this.$emit('changeForm', resData);
        });
      });
    },
    /**
     * 计算
     */
    scriptToCalculate(field, row, target, option) {
      let { calculateConfig } = field;
      if (!calculateConfig || (calculateConfig.trigger == 'appendButton' && !target)) return; //按钮触发的输入框不触发
      let that = this;
      // 计算
      let script = this.options.scripts && this.options.scripts[calculateConfig.scriptId];
      if (calculateConfig.groovyScriptId) {
        // 后端计算
        this.osg.ajax(
          'groovyScript/operation.do',
          {
            data: JSON.stringify(
              Object.assign(row, {
                groovyScriptId: calculateConfig.groovyScriptId
              })
            )
          },
          res => {
            if (script) {
              try {
                eval(script);
              } catch (e) {
                console.log(`错误字段：${field.nameDisp}-${field.name}`, e.toString());
              }
            }
          }
        );
      } else if (calculateConfig.scriptId) {
        // 前端计算
        if (script) {
          try {
            eval(script);
          } catch (e) {
            console.log(`错误字段：${field.nameDisp}-${field.name}`, e.toString());
          }
        }
      }
    },
    getScriptToCalculate(scriptId, formData, scriptParams) {
      let that = this;
      this.osg.ajax(
        'groovyScript/findByIds.do',
        {
          page: 1,
          rows: 1,
          notFilterOrgId: '1',
          notFilterBelongTo: '1',
          ids: scriptId
        },
        res => {
          if (res.data.length > 0 && res.data[0].scriptContent)
            try {
              eval(res.data[0].scriptContent);
            } catch (e) {
              console.log('脚本报错：', e.toString());
            }
        }
      );
    },

    // 地图选点 参数为经纬度
    initMap(gpsPoint = {}) {
      let _that = this;
      const { latitude = null, longitude = null } = gpsPoint;
      window._AMapSecurityConfig = {
        securityJsCode: '3788aba03fd31c6043d09d13ef61a9fd'
      };
      AMapLoader.load({
        key: '1a9bad1cbe81dd0c59194c657566254b', //此处填入我们注册账号后获取的Key
        version: '2.0', //指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Geocoder'] //需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then(async AMap => {
          // 如果gpsPoint存在有效经纬度
          if (latitude && longitude) {
            initializeMap(longitude, latitude);
          } else {
            let locationData = JSON.parse(sessionStorage.getItem('gpsPoint'));
            // 检查数据是否存在
            if (locationData) {
              initializeMap(locationData.longitude, locationData.latitude);
            } else {
              initializeMap(116.442274, 39.919265);
              this.osg.toast('获取位置权限失败', 'error');
            }
          }

          // 地图初始化方法
          function initializeMap(longitude, latitude) {
            _that.record.map = new AMap.Map('container', {
              viewMode: '2D', // 是否为3D地图模式
              zoom: 18, // 初始化地图级别
              center: [longitude, latitude] // 使用指定的经纬度作为地图中心
            });

            _that.record.mapMarker = new AMap.Marker({
              position: [longitude, latitude],
              icon: 'https://pub.fsgo365.cn/poi-marker-technician.png',
              offset: new AMap.Pixel(-13, -30),
              // 设置是否可以拖拽
              draggable: true,
              cursor: 'move'
            });

            _that.record.geocoder = new AMap.Geocoder({});
            _that.record.mapMarker.setMap(_that.record.map);

            _that.record.mapMarker.on('dragend', _that.handleMarkerDragEnd);

            _that.record.map.on('click', _that.handleMapClick);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 打开地图弹窗窗
    openLocationPicker() {
      this.record.openMap = true;
      this.initMap(this.formData.gpsPoint);
    },
    // 关闭地图弹窗窗
    closeLocationPicker() {
      this.record.openMap = false;
      this.record.values = '';
    },
    //地图弹窗确定按钮
    confirmAddress() {
      this.record.openMap = false;
      let addressInfo = this.record.values.trim();
      // this.formData.address = addressInfo;

      //从 this.record.mapMarker 实例上面拿到地图经纬度
      let mapValues = this.record.mapMarker;
      if (!addressInfo && mapValues && mapValues._position && Array.isArray(mapValues._position)) {
        // 这里的逻辑会在 _position 是非空数组时执行
        const coordArray = mapValues._position.join(',');
        this.osg.geocodeRegeo(
          coordArray,
          ({ formatted_address }) => {
            this.osg.inputtips(formatted_address, res => {
              if (res && res[0]) {
                const nearestAddress = this.findNearestAddress(
                  mapValues._position[0],
                  mapValues._position[1],
                  res
                );

                if (nearestAddress) {
                  this.osg.inputtipsSelect(nearestAddress, undefined, this);
                  let addressInfo =
                    nearestAddress.district + nearestAddress.address + nearestAddress.name;
                  this.formData.address = nearestAddress.address + nearestAddress.name;
                  this.record.values = addressInfo;
                }
              }
            });
          },
          false
        );
      }
    },
    //输入框选中事件
    handleInputtipsSelect(item) {
      const location = item.location;
      const [lng, lat] = location.split(',');
      this.osg.inputtipsSelect(item, undefined, this);
      let addressInfo = item.district + item.address + item.name;
      this.formData.address = item.address + item.name;
      this.record.infowindow = new AMap.InfoWindow({
        content: `<div style="white-space: nowrap;">
                  <h3>高德地图</h3>
                  <div>${addressInfo}</div>
                </div>`,
        offset: new AMap.Pixel(0, -80),
        size: new AMap.Size(0, 0),
        anchor: 'center',
        autoMove: true,
        avoid: [200, 200, 200, 200]
      });
      this.record.infowindow.open(this.record.map, new AMap.LngLat(lng, lat));
    },
    //标记点 移动后触发的事件
    handleMarkerDragEnd(event) {
      const { lng, lat } = event.lnglat;
      this.osg.geocodeRegeo(
        `${lng},${lat}`,
        ({ formatted_address }) => {
          this.osg.inputtips(formatted_address, res => {
            if (res && res[0]) {
              const nearestAddress = this.findNearestAddress(lng, lat, res);
              if (nearestAddress) {
                nearestAddress.move = true;
                this.osg.inputtipsSelect(nearestAddress, undefined, this);
                let addressInfo =
                  nearestAddress.district + nearestAddress.address + nearestAddress.name;
                this.formData.address = nearestAddress.address + nearestAddress.name;
                this.record.values = addressInfo;
                this.record.infowindow = new AMap.InfoWindow({
                  content: `<div style="white-space: nowrap;">
                  <h3>高德地图</h3>
                  <div>${addressInfo}</div>
                </div>`,
                  offset: new AMap.Pixel(0, -80),
                  size: new AMap.Size(0, 0),
                  anchor: 'center',
                  autoMove: true,
                  avoid: [200, 200, 200, 200]
                });
                this.record.infowindow.open(this.record.map, new AMap.LngLat(lng, lat));
              }
            }
          });
        },
        false
      );
    },
    //地图 点击触发的事件
    handleMapClick(e) {
      const { lng, lat } = e.lnglat;
      this.handleMarkerDragEnd(e);
      this.record.mapMarker.setPosition([lng, lat]);
    },
    /**
     * 计算两点之间的距离（单位：公里）
     * @param {number} lng1 - 第一个地点的经度
     * @param {number} lat1 - 第一个地点的纬度
     * @param {number} lng2 - 第二个地点的经度
     * @param {number} lat2 - 第二个地点的纬度
     * @returns {number} - 两点之间的距离（公里）
     */
    calculateDistance(lng1, lat1, lng2, lat2) {
      const radLat1 = (Math.PI * lat1) / 180.0;
      const radLat2 = (Math.PI * lat2) / 180.0;
      const radLng1 = (Math.PI * lng1) / 180.0;
      const radLng2 = (Math.PI * lng2) / 180.0;
      const a = radLat1 - radLat2;
      const b = radLng1 - radLng2;
      const distance =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
          )
        );
      return distance * 6371; // 返回距离，单位是公里
    },
    /**
     * 找到距离指定经纬度最近的地址
     * @param {number} lng - 当前经度
     * @param {number} lat - 当前纬度
     * @param {Array} res - 地址数据列表，每个地址项应包含 location 属性（"lng,lat" 字符串）
     * @returns {Object} - 最近的地址信息
     */
    findNearestAddress(lng, lat, res) {
      let nearestAddress = null;
      let minDistance = Infinity;
      res.forEach(item => {
        const locationStr = item.location; // 获取地址项的 location 字符串
        if (locationStr) {
          const [lngLoc, latLoc] = locationStr.split(',').map(Number); // 转换成经纬度数字
          const distance = this.calculateDistance(lng, lat, lngLoc, latLoc);
          if (distance < minDistance) {
            minDistance = distance;
            nearestAddress = item;
          }
        }
      });

      return nearestAddress;
    },
    handleEnterSelect() {
      const autocomplete = this.$refs.autocomplete;
      if (autocomplete && autocomplete.suggestions.length > 0) {
        // 获取第一个建议项
        const firstItem = autocomplete.suggestions[0];

        // 高亮第一项
        autocomplete.highlightedIndex = 0;

        // 短暂延时后选中并关闭下拉框
        setTimeout(() => {
          // 强制关闭下拉框
          autocomplete.suggestionVisible = false;
          // 清空建议列表
          autocomplete.suggestions = [];
          // 执行选中操作
          this.handleInputtipsSelect(firstItem);
          // 重新激活建议功能
          autocomplete.activated = true;
        }, 100);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.c-form-item-richText {
  display: flex;
  flex-direction: column;
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}
.biz-select ::v-deep .el-input__suffix {
  z-index: 1;
}

::v-deep .amap-marker-label {
  border: 0;
  background-color: transparent;
  font-size: 20px;
  padding: 5px;
  border-radius: 0.25rem;
  background-color: white;
  border-width: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  .info {
    width: min-content;
    height: 30px;
  }
}
</style>
<style>
.el-upload-list__item.is-success.focusing .el-icon-close-tip {
  display: none !important;
}
.c-form-dialog {
  width: 1000px !important;
}
.el-autocomplete-suggestion {
  width: auto !important;
}
.biz-select .el-select__tags {
  padding-left: 30px;
  width: calc(100% - 60px);
}
</style>
